<template>
  <div class="battle-detail">
    <div class="zz-page battle-room">
      <div class="page-content-new flex-box-div">
        <!-- 头部 -->
        <otherHeaderTop
          headerTitle="盲盒对战"
          :showBack="true"
          @back="back"
          :showBalanceOne="false"
        ></otherHeaderTop>
        <div class="detail-content">
          <div class="filter-flex">
            <div class="info-box">
              <div class="info-inner">
                <div class="round-info">
                  <img
                    src="../../assets/images/box-items-icon.png"
                    class="round-ic"
                    mode="aspectFit"
                  />
                  <!-- 等待中 -->
                  <template v-if="battleStatus == 0">
                    <span class="round-tv">
                      0/{{ fightRoom.roundNumber }}
                    </span>
                  </template>
                  <!-- 对战中 -->
                  <template v-if="battleStatus == 1">
                    <span class="round-tv">
                      {{ step }}/{{ fightRoom.roundNumber }}
                    </span></template
                  >
                  <!-- 结束查看详情 -->
                  <template v-if="battleStatus == 2">
                    <span class="round-tv">
                      {{ fightRoom.roundNumber }}/{{ fightRoom.roundNumber }}
                    </span></template
                  >
                  <!-- <span class="round-tv">
                    {{
                      info.status == 1
                        ? 0
                        : info.status == 3
                        ? info.boxInfo.length
                        : step <= info.boxInfo.length
                        ? step
                        : info.boxInfo.length
                    }}/{{ info.boxInfo.length }}
                  </span> -->
                </div>
                <div class="amount-info">
                  <img
                    src="../../assets/images/balance1.png"
                    class="coin"
                    mode="aspectFit"
                  />
                  <!-- <span>{{ calculateTotalPrice(fightRoom.boxData) }}</span> -->
                  <span>{{ fightRoom.boxPriceTotal }}</span>
                  <!-- <span v-if="battleStatus == 1">{{ info.total_price }}</span> -->
                  <!-- <span v-if="battleStatus == 2">{{ info.total_price }}</span> -->
                </div>
                <div class="box-list flex-center box-list-d">
                  <div
                    class="swiper-container swiper-box swiper-container-initialized swiper-container-horizontal"
                  >
                        <!-- align-items: center; -->
                        <!-- justify-content: center; -->
                    <div
                      style="
                        display: flex;
                        flex-wrap: nowrap;
                      "
                    >
                      <!-- 等待对战中 -->
                      <template
                        v-for="(item, index) in expandAllBoxes(
                          fightRoom.boxData,
                          fightRoom.boxSequence
                        )"
                      >
                        <!-- <div
                          class="sel-item pointer swiper-slide swiper-slide-active"
                          @click.stop="openBoxDetail(item)"
                          v-for="(itm, idx) in getBoxes(item)"
                          :key="`${item.boxId}-${idx}`" -->
                        <div
                          class="sel-item pointer swiper-slide swiper-slide-active"
                          @click.stop="openBoxDetail(item)"
                          :key="`${item.boxId}`"
                          :class="[
                            battleStatus == 1 &&
                            step <= fightRoom.roundNumber &&
                            step == index + 1
                              ? 'sel-item-d'
                              : '',
                          ]"
                        >
                          <!-- :class="[
                          info.status == 2 &&
                          step <= info.boxInfo.length &&
                          step == index + 1
                            ? 'sel-item-d'
                            : '',
                        ]" -->
                          <div class="tag-slide-item">
                            <!-- {{ idx }} -->
                            <!-- <img
                              style="width: 40%; z-index: 9; left: 29%"
                              :src="item.boxImg02 | fullPath"
                              class="item-img"
                              mode="aspectFit"
                            /> -->
                            <img
                             style="width: 70%;height:auto; z-index: 9; left: 10%;top:30%;"
                              :src="`${$getFullPath(item.boxImg02)}`"
                              class="item-img"
                              mode="aspectFit"
                            />
                            <img
                              :src="`${$getFullPath(item.boxImg01)}`"
                              class="item-img"
                              mode="aspectFit"
                            />
                            <div
                              v-if="
                                battleStatus == 1 &&
                                step <= fightRoom.roundNumber &&
                                step == index + 1
                              "
                              class="run-active"
                            ></div>
                            <div class="price flex-center">
                              <img
                                src="../../assets/images/balance1.png"
                                class="coin"
                                mode="aspectFit"
                              />
                              <!-- <span class="price-data">{{ item.price }}</span> -->
                              <span class="price-data">{{ item.price }}</span>
                              <!-- <span class="price-data">{{step}}--{{ index + 1  }}</span> -->
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="anim-box"
              :style="{ 'overflow-y': battleStatus == 2 ? 'scroll' : 'auto' }"
            >
              <div class="pk-anim-new">
                <div class="text-no-select">
                  <div
                    class="pk-anim-box pk-anim-box-d"
                    v-if="battleStatus == 1"
                  >
                    <div class="bt-open-anim">
                      <div class="open-round abs-base">
                        {{ fightRoom.roundNumber }}回合
                      </div>
                      <div class="open-anim-3">
                        <div class="top-line">
                          <div class="abs-full inner-gif"></div>
                        </div>
                        <!-- 开奖箱子 -->
                        <div class="list-box" v-if="openProducts.length > 0">
                          <div
                            class="outer-box"
                            v-for="(p, i) of fightRoom.seats"
                            :key="i"
                          >
                            <div class="inner-box">
                              <div
                                class="anim-box"
                                :style="{
                                  transform: `translate3d(0px, ${dynamicDeg}px, 0px)`,
                                }"
                              >
                                <div
                                  class="item-box"
                                  v-for="(item, index) in openProducts[i]"
                                  :class="[p_bg[item.ornamentsLevelId - 1]]"
                                >
                                  <div class="item-color">
                                    <img
                                      :src="item.imageUrl"
                                      alt=""
                                      class="item-prod"
                                      mode="aspectFit"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 等待中 -->
                  <template>
                    <div class="anim-ctx">
                      <div
                        class="user-anim"
                        :class="[
                          `user-anim-${fightRoom.playerNum}`,
                          battleStatus == 0
                            ? seats[index].avatar == null
                              ? 'user-anim-wait'
                              : 'user-anim-ready'
                            : battleStatus == 1
                            ? 'user-anim-anim'
                            : battleStatus == 2 && seats[index].isWinner
                            ? 'user-anim-win'
                            : 'user-anim-loss',
                        ]"
                        v-for="(i, index) of fightRoom.playerNum"
                        :key="index"
                      >
                        <div
                          class="user-info"
                          :class="[`user-info-${fightRoom.playerNum}`]"
                        >
                          <div class="avatar-box flex-center">
                            <div class="avatar-inner">
                              <img
                                v-if="seats[index].avatar == null"
                                src="../../assets/images/battle_no_join_avatar.png"
                                class="abs-full a-img"
                                mode="aspectFit"
                              />
                              <img
                                v-else
                                :src="`${$getFullPath(seats[index].avatar)}`"
                                class="abs-full a-img"
                                mode="aspectFit"
                              />
                              <!-- <img
                                v-else
                                :src="seats[index].avatar"
                                class="abs-full a-img"
                                mode="aspectFit"
                              /> -->
                              <div class="abs-full avatar-mask"></div>
                            </div>
                          </div>
                          <div class="nick-name flex-center">
                            <span class="nick text-ellipsis">
                              <template v-if="seats[index].nickName == null"
                                >等待玩家</template
                              >
                              <template v-else>
                                {{ seats[index].nickName }}
                              </template>
                            </span>
                          </div>
                          <div class="win-price">
                            <div class="user-m-top flex-center">
                              <span v-if="battleStatus != 0" class="top-m-anim">
                                <span class="flex-center">
                                  <span class="user-money">
                                    <!-- {{ seats[index] }} -->
                                    <!-- {{ seats[index].winTotalBoxPrice }} -->
                                    {{
                                      battleStatus == 2
                                        ? seats[index].winTotalBoxPrice
                                        : seats[index].awardTotalPrices
                                    }}
                                    <!-- <span>{{
                                    info.player_info[index].actual_total_amount
                                  }}</span> -->
                                  </span>
                                </span>
                              </span>
                            </div>
                            <div class="user-m-btm flex-center">
                              <span v-if="battleStatus == 2" class="btm-m-aim">
                                <span class="orig-money orig-money-d">
                                  {{ seats[index].awardTotalPrices }}
                                  <!-- {{seats[index].isWinner}} -->
                                  <!-- {{ totalPrize }} -->
                                  <!-- {{
                                  Number(
                                    info.player_info[index].total_amount
                                  ).toFixed(2)
                                }} -->
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="top-box"
                          :class="[`top-box-${fightRoom.playerNum}`]"
                        >
                          <div class="state-box" v-if="battleStatus == 0">
                            <div class="state-box-inner flex-center">
                              <img
                                v-if="seats[index].avatar == null"
                                class="state-img wait-img"
                                src="../../assets/images/wait_img.png"
                                mode="aspectFit"
                              />
                              <img
                                v-else
                                class="state-img ready-img"
                                src="../../assets/images/ready_img.png"
                                mode="aspectFit"
                              />
                            </div>
                          </div>
                          <!-- {{ getResultImg(seats[index]) }} -->
                          <template v-if="battleStatus == 2">
                            <div class="result-box flex-center">
                              <div
                                v-if="seats[index].isWinner"
                                class="win-result"
                              ></div>
                              <div v-else class="loss-result">
                                <img
                                  :src="`${$getFullPath(getResultImg(seats[index]).imageUrl)}`
                                  "
                                  class="goods-img abs-base"
                                  mode="aspectFit"
                                />
                                <div class="loss-name abs-base text-ellipsis">
                                  {{ getResultImg(seats[index]).ornamentName }}
                                </div>
                                <div class="loss-price text-ellipsis">
                                  {{
                                    getResultImg(seats[index]).ornamentsPrice
                                  }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="user-content">
                          <div class="user-orig-m flex-center">
                            <div
                              class="join-btn"
                              v-if="seats[index].avatar == null"
                            >
                              <div
                                @click="verifyReady"
                                class="user-join-btn"
                                :style="{
                                  transform: `scale(${
                                    fightRoom.playerNum == 2 ? '1' : '0.8'
                                  })`,
                                }"
                              >
                                加入
                              </div>
                            </div>
                          </div>

                          <!-- <div
                            class="prod-list"
                            v-if="fightRoom.status != 1" -->
                          <div class="prod-list">
                            <template v-if="battleStatus == 1">
                              <div class="prize-inner-arr">
                                <div>
                                  <div
                                    class="item-outer"
                                    :class="[itm.class ? itm.class : '']"
                                    v-for="(itm, ix) in winner_owner[index]"
                                    :key="ix"
                                  >
                                    <template
                                      v-if="index < fightRoom.playerNum - 1"
                                    >
                                      <div class="index-tag">
                                        {{
                                          winner_owner[index].length -
                                          1 -
                                          ix +
                                          1
                                        }}
                                      </div>
                                    </template>
                                    <div
                                      class="prod-item"
                                      :class="[p_bg[itm.ornamentsLevelId - 1]]"
                                    >
                                      <div
                                        class="color-bg 1111"
                                        :class="[
                                          p_bg[itm.ornamentsLevelId - 1],
                                        ]"
                                      ></div>

                                      <div class="inner-img flex-center">
                                        <img
                                          :src="itm.imageUrl"
                                          class="prod"
                                          mode="aspectFit"
                                        />
                                      </div>
                                      <div class="inner-info">
                                        <!-- <div class="title text-ellipsis">
                                          {{ getName(itm.name, 1) }}
                                        </div> -->
                                        <div class="title text-ellipsis">
                                          {{ itm.ornamentName }}
                                        </div>
                                        <div class="money flex-center">
                                          <img
                                            src="../../assets/images/balance1.png"
                                            class="coin"
                                            mode="aspectFit"
                                          />
                                          <span class="price">{{
                                            itm.usePrice
                                          }}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-if="battleStatus == 2">
                              <div class="prize-inner-arr">
                                <div>
                                  <div
                                    class="item-outer"
                                    v-for="(itm, ix) in getResultBox(
                                      seats[index]
                                    )"
                                    :key="ix"
                                  >
                                    <template
                                      v-if="index < fightRoom.playerNum - 1"
                                    >
                                      <div class="index-tag">
                                        {{
                                          getResultBox(seats[index]).length -
                                          1 -
                                          ix +
                                          1
                                        }}
                                      </div>
                                    </template>
                                    <div
                                      class="prod-item"
                                      :class="[p_bg[itm.ornamentsLevelId - 1]]"
                                    >
                                      <div
                                        class="color-bg 333"
                                        :class="[
                                          p_bg[itm.ornamentsLevelId - 1],
                                        ]"
                                      ></div>
                                      <div
                                        class="prod-tag"
                                        v-if="
                                          battleStatus == 2 &&
                                          !seats[index].isWinner
                                        "
                                      >
                                        掠夺
                                      </div>
                                      <div class="inner-img flex-center">
                                        <!-- {{ ix }} -->
                                        <img
                                          :src="itm.imageUrl"
                                          class="prod"
                                          mode="aspectFit"
                                        />
                                      </div>
                                      <div class="inner-info">
                                        <div class="title text-ellipsis">
                                          {{ itm.ornamentName }}
                                        </div>
                                        <div class="money flex-center">
                                          <img
                                            src="../../assets/images/balance1.png"
                                            class="coin"
                                            mode="aspectFit"
                                          />
                                          <span class="price">{{
                                            itm.ornamentsPrice
                                          }}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- <div class="anim-ctx">
                    <div
                      class="user-anim"
                      :class="[
                        `user-anim-${fightRoom.playerNum}`,
                        battleStatus == 0
                          ? seats[index].avatar == null
                            ? 'user-anim-wait'
                            : 'user-anim-ready'
                          : battleStatus == 1
                          ? 'user-anim-ready'
                          : info.open_box_num == 0
                          ? 'user-anim-anim'
                          : seats[index].avatar &&
                            info.winner.includes(info.player_info[index].id)
                          ? 'user-anim-win'
                          : 'user-anim-loss',
                      ]"
                      v-for="(i, index) of fightRoom.playerNum"
                      :key="index"
                    >
                      <div
                        class="user-info"
                        :class="[`user-info-${fightRoom.playerNum}`]"
                      >
                        <div class="avatar-box flex-center">
                          <div class="avatar-inner">
                            <img
                              v-if="seats[index].avatar == null"
                              src="../../assets/images/battle_no_join_avatar.png"
                              class="abs-full a-img"
                              mode="aspectFit"
                            />
                            <img
                              v-else
                              :src="
                              seats[index].avatar
                              "
                              class="abs-full a-img"
                              mode="aspectFit"
                            />
                            <div class="abs-full avatar-mask"></div>
                          </div>
                        </div>
                        <div class="nick-name flex-center">
                          <span class="nick text-ellipsis">
                            <template v-if="seats[index].nickName == null"
                              >等待玩家</template
                            >
                            <template v-else>
                              {{ seats[index].nickName }}
                            </template>
                          </span>
                        </div>
                        <div class="win-price">
                          <div class="user-m-top flex-center">
                            <span v-if="info.status != 1" class="top-m-anim">
                              <span class="flex-center">
                                <span class="user-money">
                                  <span>{{
                                    info.player_info[index].actual_total_amount
                                  }}</span>
                                </span>
                              </span>
                            </span>
                          </div>
                          <div class="user-m-btm flex-center">
                            <span v-if="info.status == 3" class="btm-m-aim">
                              <span class="orig-money orig-money-d">
                                {{
                                  Number(
                                    info.player_info[index].total_amount
                                  ).toFixed(2)
                                }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="top-box" :class="[`top-box-${info.mode}`]">
                        <div class="state-box">
                          <div class="state-box-inner flex-center">
                            <img
                              v-if="info.player_info[index] == null"
                              class="state-img wait-img"
                              src="../../assets/images/wait_img.png"
                              mode="aspectFit"
                            />
                            <img
                              v-else-if="info.status == 1"
                              class="state-img ready-img"
                              src="../../assets/images/ready_img.png"
                              mode="aspectFit"
                            />
                          </div>
                        </div>
                        <div
                          v-if="info.status == 3"
                          class="result-box flex-center"
                        >
                          <div
                            v-if="
                              info.player_info[index] &&
                              info.winner.includes(info.player_info[index].id)
                            "
                            class="win-result"
                          ></div>
                          <div v-else class="loss-result">
                            <img
                              :src="
                                info.loser_reward && info.loser_reward.imageUrl
                              "
                              class="goods-img abs-base"
                              mode="aspectFit"
                            />
                            <div class="loss-name abs-base text-ellipsis">
                              {{
                                info.loser_reward && info.loser_reward.itemName
                              }}
                            </div>
                            <div class="loss-price text-ellipsis">
                              {{ info.loser_reward && info.loser_reward.price }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="user-content">
                        <div class="user-orig-m flex-center">
                          <div
                            class="join-btn"
                            v-if="info.player_info[index] == null"
                          >
                            <div
                              @click="doJoin(1)"
                              v-if="user && user.id == info.home_owner"
                              class="user-join-btn"
                              :style="{
                                transform: `scale(${
                                  info.mode == 2 ? '1' : '0.8'
                                })`,
                              }"
                            >
                              邀请官方人机
                            </div>
                            <div
                              @click="doJoin(2)"
                              v-else
                              class="user-join-btn"
                              :style="{
                                transform: `scale(${
                                  info.mode == 2 ? '1' : '0.8'
                                })`,
                              }"
                            >
                              加入
                            </div>
                          </div>
                        </div>

                        <div
                          class="prod-list"
                          v-if="info.status != 1"
                          :style="{
                            'clip-path':
                              info.status === 2
                                ? 'polygon(0 0, 140% 0, 100% 100%, 0 100%)'
                                : 'none',
                          }"
                        >
                          <template v-if="info.status == 2">
                            <div
                              class="prize-inner-arr"
                              :style="{
                                transform: `translateY(${translateYValue})`,
                              }"
                            >
                              <div>
                                <div
                                  class="item-outer"
                                  :class="[itm.class ? itm.class : '']"
                                  v-for="(itm, ix) in winner_owner[index]"
                                  :key="ix"
                                >
                                  <template v-if="index < info.mode - 1">
                                    <div class="index-tag">
                                      {{
                                        winner_owner[index].length - 1 - ix + 1
                                      }}
                                    </div>
                                  </template>
                                  <div class="prod-item" :class="[p_bg[0]]">
                                    <div
                                      class="color-bg"
                                      :class="[p_bg[0]]"
                                    ></div>
                                    <div
                                      class="prod-tag"
                                      v-if="
                                        info.status == 3 &&
                                        info.player_info[index] &&
                                        !info.winner.includes(
                                          info.player_info[index].id
                                        )
                                      "
                                    >
                                      掠夺
                                    </div>
                                    <div class="inner-img flex-center">
                                      <img
                                        :src="itm.img"
                                        class="prod"
                                        mode="aspectFit"
                                      />
                                    </div>
                                    <div class="inner-info">
                                      <div class="title text-ellipsis">
                                        {{ getName(itm.name, 1) }}
                                      </div>
                                      <div class="title text-ellipsis">
                                        {{ getName(itm.name, 2) }}
                                      </div>
                                      <div class="money flex-center">
                                        <img
                                          src="../../assets/images/balance1.png"
                                          class="coin"
                                          mode="aspectFit"
                                        />
                                        <span class="price">{{
                                          itm.price
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="info.status == 3">
                            <div class="prize-inner-arr">
                              <div>
                                <div
                                  class="item-outer"
                                  :class="[itm.class ? itm.class : '']"
                                  v-for="(itm, ix) in winner_owner[index]"
                                  :key="ix"
                                >
                                  <template v-if="index < info.mode - 1">
                                    <div class="index-tag">
                                      {{
                                        winner_owner[index].length - 1 - ix + 1
                                      }}
                                    </div>
                                  </template>
                                  <div class="prod-item" :class="[p_bg[0]]">
                                    <div
                                      class="color-bg"
                                      :class="[p_bg[0]]"
                                    ></div>
                                    <div
                                      class="prod-tag"
                                      v-if="
                                        info.status == 3 &&
                                        info.player_info[index] &&
                                        !info.winner.includes(
                                          info.player_info[index].id
                                        )
                                      "
                                    >
                                      掠夺
                                    </div>
                                    <div class="inner-img flex-center">
                                      <img
                                        :src="itm.img"
                                        class="prod"
                                        mode="aspectFit"
                                      />
                                    </div>
                                    <div class="inner-info">
                                      <div class="title text-ellipsis">
                                        {{ getName(itm.name, 1) }}
                                      </div>
                                      <div class="title text-ellipsis">
                                        {{ getName(itm.name, 2) }}
                                      </div>
                                      <div class="money flex-center">
                                        <img
                                          src="../../assets/images/balance1.png"
                                          class="coin"
                                          mode="aspectFit"
                                        />
                                        <span class="price">{{
                                          itm.price
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="btm-cover"></div>
          </div>
        </div>
        <div
          v-if="battleStatus == 1 && !isInclude(fightRoom.seats, userId)"
          class="battle-room-div flex-center"
        >
          观战对战中...
        </div>
      </div>
    </div>
    <!-- 盲盒详情 -->
    <modalBoxDetail
      :showModal="showDetail"
      :info="curBox"
      @close="showDetail = false"
    ></modalBoxDetail>
    <!-- 对战结果 -->
    <modalBoxResult
      :showModal="showBoxResult"
      :num="isActive"
      :skinsInfo="skinsInfo"
      @close="showBoxResult = false"
    ></modalBoxResult>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import lotterySeat from "@/components/pkHome/lotterySeat.vue";
import modalBoxDetail from "@/components/common/modalBoxDetail.vue";
import modalBoxResult from "@/components/common/modalBoxResult.vue";
// import countTo from "vue-count-to";
// import lotteryRounds from "@/components/pkHome/lotteryRounds.vue";
/* import Vue from 'vue' */

// import store from "@/vuex/store";
// import { scoket } from "@/api/scoket";
import boxDetail from "./boxDetail.vue";
import {
  audience,
  getUserInfo,
  ApiSeatReady, //玩家准备
  Playthegame, //开始游戏
  Gameover, //游戏结束
  joinFightverify,
  createFight,
  fightDetail, //获取对战详情
} from "@/api/index";

import bsurl from "@/api/basurl.js";
// import { get } from "core-js/core/dict";

export default {
  components: {
    boxDetail,
    lotterySeat,
    otherHeaderTop,
    modalBoxDetail,
    modalBoxResult,
  },
  data() {
    return {
      // 开箱结果盒子
      showBoxResult: false,
      isActive: 1,
      skinsInfo: [],
      num: 0,
      copy: false,
      //老虎机滚动时间
      singlePlayTime: 4,
      //debug 老虎机实时速度
      debugSpeed: null,
      resultLocation: new Map(),
      // 对战结果集（后端数据结构）
      // private Integer WinnerId;
      // // 开箱结果
      // private List<TtBoxRecords> fightResult;
      // // 宝箱详情
      // private List<FightBoxVO> fightBoxVOList;
      // 整理后是map
      fightResult: new Map(),
      battleResultData: [],
      fightRoom: {
        boxData: [],
      }, // 对战房间信息
      seats: {}, // 对战房间信息
      winnerId: null,
      location_y: 0,
      // 本局奖金总额
      // 完成抽奖的人数
      allEndNumber: 0,
      roomstatus: null,
      loading: true, //动画结束的显示隐藏
      begin: false,
      title: "",
      isjoin: false,
      id: this.$route.query.id,
      roomList: [], //全部数据,
      currentRound: 1,
      svgW: 0, //svg图标的尺寸
      flag: false, //是否展示横线
      boxDetail: {
        flag: false,
        boxId: "",
      },
      isready: false,
      // 当前状态
      battleStatus: this.$route.query.battleStatus, //0未开始 1开始 2结束
      // 新的
      showDetail: false,
      p_bg: ["golden", "red", "purple", "blue"],
      user: {},
      step: 0,
      info: {
        boxInfo: [],
      },
      // id: 0,
      winner_owner: [],
      openProducts: [],
      dynamicDeg: -50,
      timeout: null,
      // 动画状态
      animationStatus: false,
      translateYValue: "-100%",
      isFirstCall: false,
      timer1: null,
      timer2: null,
      timer3: null,
      showDetail: false,
      curBox: {
        boxList: {
          skins_types: [],
          box_skins: [],
        },
      },
      resultData: [],
      userId: 0,
    };
  },
  computed: {
    boxList() {
      let arr = [];
      let obj = this.fightRoom.boxData;
      let key;
      for (key in obj) {
        for (let i = 1; i <= obj[key].number; i++) {
          arr.push(obj[key]);
        }
      }
      return arr;
    },

    // arr() {
    //   let a = [];
    //   let b = [];
    //   console.log("对战结果", this.fightResult);
    //   this.fightResult.forEach((value) => {
    //     a.push(...value);
    //   });
    //   a.forEach((item) => {
    //     if (item.holderUserId == this.playerId) {
    //       b.push(item);
    //     }
    //   });
    //   return b;
    // },
    // totalPrize() {
    //   let total = this.arr.reduce((currentValue, item) => {
    //     return item.ornamentsPrice + currentValue;
    //   }, 0);
    //   return total;
    // },
  },
  beforeRouteLeave(to, from, next) {
    this.$soundStop("boxAnimBattle");
    this.$soundPlay("click"); // 如果需要在离开时播放点击声
    this.clearAllTimers();
    next();
  },
  methods: {
    expandBoxes(box) {
      const { number, ...rest } = box; // 解构出 number 和其他属性
      return Array.from({ length: number }, (_, index) => ({
        ...rest, // 复制原始对象的所有属性
        boxIndex: index + 1, // 添加一个新的属性表示这是第几个箱子
        boxImg: index === 0 ? box.boxImg01 : box.boxImg02, // 根据索引选择不同的图片
      }));
    },

    expandAllBoxes(boxes, boxSequence) {
      // console.log("boxes", boxes,'boxSequence',boxSequence);
      // 如果 boxes 是一个数组或对象，先获取所有箱子对象
      let allBoxes = [];
      if (Array.isArray(boxes)) {
        allBoxes = boxes;
      } else if (typeof boxes === "object" && boxes !== null) {
        allBoxes = Object.values(boxes);
      } else if (
        typeof boxes === "object" &&
        boxes !== null &&
        "boxId" in boxes
      ) {
        allBoxes = [boxes];
      } else {
        console.warn("Invalid input type for expandAllBoxes");
        return [];
      }

      // 将 boxSequence 转换为数组
      const sequenceArray = boxSequence
        ? boxSequence.split(",").map((id) => id.trim())
        : [];

      // 根据 boxSequence 的顺序筛选和排序箱子
      const result = sequenceArray
        .map((boxId) => {
          // 查找与 boxId 匹配的箱子
          return allBoxes.find((box) => box.boxId.toString() === boxId);
        })
        .filter((box) => box !== undefined); // 过滤掉未找到的箱子

      // 返回按顺序排列的箱子
      console.log("result11111", result);
      return result;
    },
    isInclude(seats, targetPlayerId) {
      const result = seats.some((seat) => seat.playerId === targetPlayerId);
      return result;
    },
    calculateTransform() {},
    getName(name, type) {},
    changeShowDetail() {},
    doJoin() {},
    getInfo() {},
    clearTimeoutInterval() {},
    getResults() {},
    setbattlestatus() {},
    
    // 计算箱子价格
    calculateTotalPrice(boxData) {
      // 检查 boxData 是否为对象且不为空
      if (typeof boxData !== "object" || boxData === null) {
        throw new Error("Invalid boxData object");
      }

      // 初始化总价为 0
      let totalPrice = 0;

      // 遍历 boxData 中的每一个 item
      for (const key in boxData) {
        if (boxData.hasOwnProperty(key)) {
          const item = boxData[key];

          // 检查 item 是否包含 number 和 price 属性
          if (
            typeof item !== "object" ||
            !("number" in item) ||
            !("price" in item)
          ) {
            throw new Error(`Invalid item object for boxId: ${key}`);
          }

          // 累加每个 item 的价格
          totalPrice += item.number * item.price;
        }
      }

      // 返回计算后的总价
      return totalPrice;
    },
    openBoxDetail(item) {
      this.$soundPlay("click");
      this.showDetail = true;
      this.curBox = item;
    },
    getOpenProducts() {
      // 开箱的进度
      this.step += 1;
      this.openProducts = [];
      // 如果开奖的进度大于箱子的进度，那么结束开奖
      if (this.step > this.fightRoom.roundNumber) {
        this.step -= 1;
        // 更新 URL 的 battleStatus 参数为 2
        const query = { ...this.$route.query, battleStatus: 2 };
        this.$router.replace({ query });
        setTimeout(() => {
          this.battleStatus = 2;

          Gameover(this.fightRoom.id).then(() => {
            this.getFightDetail("over");
          });
        }, 2000);
        return;
      }

      this.dynamicDeg = -50;
      this.$forceUpdate();

      setTimeout(() => {
        this.processBattleData();
      }, 500);
    },
    processBattleData() {
      const battleData =
        this.battleResultData[0]["records"][this.step - 1]["boxInfo"];
      const newArray = Array.from(
        { length: 44 },
        (_, i) => battleData["ornaments"][i % battleData["ornaments"].length]
      );

      // 初始化 openProducts 数组
      this.openProducts = Array.from(
        { length: this.fightRoom.playerNum },
        () => [...newArray]
      );

      // 根据 step 处理数据
      // if (this.step === 1) {
      this.handleFirstStep(newArray);
      // } else {
      //   this.handleSubsequentSteps(newArray);
      //   console.log("观看模式");
      // }

      this.showDynamic();
    },
    handleFirstStep(newArray) {
      for (let i = 0; i < this.fightRoom.playerNum; i++) {
        const record = this.battleResultData[i]["records"][this.step - 1];
        const matchingOrnament = newArray.find(
          (item) => item.ornamentId === record.ornamentId
        );
        if (matchingOrnament) {
          this.openProducts[i].push(matchingOrnament);
        }
      }
    },
    handleSubsequentSteps(newArray) {
      // 处理之前的数据
      for (let i = 0; i < this.fightRoom.playerNum; i++) {
        const previousRecord =
          this.battleResultData[i]["records"][this.step - 2];
        const matchingOrnament = newArray.find(
          (item) => item.ornamentId === previousRecord.ornamentId
        );
        if (matchingOrnament) {
          this.openProducts[i].push(matchingOrnament);
        }
      }

      // 正常处理当前步的数据
      for (let i = 0; i < this.fightRoom.playerNum; i++) {
        const currentRecord =
          this.battleResultData[i]["records"][this.step - 1];
        const matchingOrnament = newArray.find(
          (item) => item.ornamentId === currentRecord.ornamentId
        );
        if (matchingOrnament) {
          this.openProducts[i].push(matchingOrnament);
        }
      }
    },
    showDynamic() {
      // const animationStep = 100 / this.info.boxInfo.length;
      if (this.isFirstCall) {
        // 第一次调用时，根据 step 判断是否需要处理之前的所有步骤
        if (this.step > 1) {
          this.processPreviousSteps(); // 先处理之前的所有步骤
          this.isFirstCall = false;
          // 更新每个玩家的总饰品价格
          this.updateAwardTotalPrices();
          this.$forceUpdate();
        }
      }
      this.timer1 = setTimeout(() => {
        this.dynamicDeg = -2902;
        this.$soundPlay("boxAnimBattle");
        this.timer2 = setTimeout(() => {
          this.processCurrentStep();
          // 更新每个玩家的总饰品价格
          this.updateAwardTotalPrices();
          this.$forceUpdate();
          this.$soundPlay("pkAnimStop");
          this.timer3 = setTimeout(() => {
            this.getOpenProducts();
          }, 500);
        }, 5000);
      }, 500);
    },
    // 清除所有定时器
    clearAllTimers() {
      if (this.timer1) clearTimeout(this.timer1);
      if (this.timer2) clearTimeout(this.timer2);
      if (this.timer3) clearTimeout(this.timer3);
    },
    // 处理当前步的数据
    processCurrentStep() {
      for (let i = 0; i < this.fightRoom.playerNum; i++) {
        const currentRecord =
          this.battleResultData[i]["records"][this.step - 1];
        const matchingOrnament = this.openProducts[i].find(
          (item) => item.ornamentId === currentRecord.ornamentId
        );
        if (matchingOrnament) {
          this.winner_owner[i].unshift(matchingOrnament);
        }
      }
    },

    // 处理之前所有步骤的数据
    processPreviousSteps() {
      for (let step = 1; step < this.step; step++) {
        for (let i = 0; i < this.fightRoom.playerNum; i++) {
          const previousRecord = this.battleResultData[i]["records"][step - 1];
          const matchingOrnament = this.openProducts[i].find(
            (item) => item.ornamentId === previousRecord.ornamentId
          );
          if (matchingOrnament) {
            this.winner_owner[i].unshift(matchingOrnament);
          }
        }
      }
    },

    updateAwardTotalPrices() {
      // 遍历 this.seats，更新每个玩家的总饰品价格
      this.seats.forEach((seat, index) => {
        // 初始化该玩家的总价格为 0
        seat.awardTotalPrices = 0;

        // 获取该玩家的所有饰品
        const playerOrnaments = this.winner_owner[index];

        // 遍历该玩家的饰品，累加 usePrice
        playerOrnaments.forEach((item) => {
          if (item.usePrice !== undefined) {
            seat.awardTotalPrices += parseFloat(item.usePrice);
          }
        });

        // 确保总价格保留两位小数
        seat.awardTotalPrices = parseFloat(seat.awardTotalPrices.toFixed(2));
      });
    },
    // 旧的
    // 获取失败的图片
    getResultImg(item) {
      return this.fightResult
        .get(item.playerId)
        .find((item) => item.boxId == null);
    },
    // 获取各自的箱子
    getResultBox(item) {
      // 检查玩家是否为赢家
      const isWinner =
        this.seats.find((seat) => seat.playerId === item.playerId)?.isWinner ||
        false;

      // 根据游戏规则和赢家数量来决定返回的饰品列表
      if (
        this.resultData.playerNum === 2 &&
        this.resultData.winnerIds.length > 1
      ) {
        // 两人游戏且有两个赢家时，各自统计饰品价格
        console.log("Two players, both winners. Returning all ornaments.");
        return this.fightResult.get(item.playerId) || [];
      } else if (
        this.resultData.playerNum === 3 &&
        this.resultData.winnerIds.length === 1
      ) {
        return isWinner
          ? this.fightResult
              .get(item.playerId)
              .filter((record) => record.userId == item.playerId) || []
          : (this.fightResult.get(item.playerId) || []).filter(
              (record) => record.boxId != null
            );
      } else if (
        this.resultData.playerNum === 3 &&
        this.resultData.winnerIds.length === 2
      ) {
        // 三人游戏且有两个赢家时，赢家拿回所有饰品，输家只拿回 boxId == null 的饰品
        console.log(
          "Three players, two winners. Winners get all ornaments, loser gets only null boxId ornaments."
        );
        return isWinner
          ? this.fightResult.get(item.playerId) || []
          : (this.fightResult.get(item.playerId) || []).filter(
              (record) => record.boxId == null
            );
      } else if (
        this.resultData.playerNum === 3 &&
        this.resultData.winnerIds.length === 3
      ) {
        // 三人平局，各自拿回所有饰品
        console.log(
          "Three players, all winners. Each player gets all their ornaments."
        );
        return this.fightResult.get(item.playerId) || [];
      } else {
        // 其他情况，按是否为赢家分配饰品
        console.log(
          "Other case. Winners get all ornaments, losers get only null boxId ornaments."
        );
        return isWinner
          ? this.fightResult
              .get(item.playerId)
              .filter(
                (record) =>
                  record.boxId != null && record.userId == item.playerId
              ) || []
          : (this.fightResult.get(item.playerId) || []).filter(
              (record) => record.boxId != null
            );
      }
    },
    // 获取观战房间数据
    getAudience() {
      audience(this.$route.query.id).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.battleStatus = 1;
          if (res.data.data.fight.status == 1) {
            this.flag = true;
          }
          this.step = data.currentRound;
          if (this.step == -1) {
            const query = { ...this.$route.query, battleStatus: 2 };
            this.$router.replace({ query });
            this.battleStatus = 2;
            this.getFightDetail();
          }
          //整理数据并渲染
          this.isFirstCall = true;
          this.getFightResult(data);
        } else if (res.data.code == 601) {
          // 获取对局信息
          this.battleStatus = 0;
          this.connectWs();
        } else {
          // this.$message({ duration: 1000,
          //   type: "warning",
          //   message: res.data.msg,
          //   customClass: "log_warning",
          // });
        }
      });
    },
    back() {
      this.$router.go(-1);
      // this.$soundStop("boxAnimBattle");
      // this.$soundPlay("click");
    },
    getBoxNumber(item) {
      // 计算箱子数量
      return item.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.number;
      }, 0);
    },
    getBoxes(item) {
      return Array.from({ length: item.number }, (_, i) => i);
    },
    boxDataArray(item) {
      return Object.values(item);
    },
    // 获取对战详情
    getFightDetail(type = "other") {
      // this.roundNu;
      fightDetail({ fightId: this.$route.query.id }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.resultData = data;

          //整理数据并渲染
          this.battleResultDataFn(data, type);
        } else {
          this.$message({
            duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      });
    },
    //整理结束数据
    battleResultDataFn(vo, type = "other") {
      // 整理战斗结果数据
      const fightRes = vo.fightResult;
      const seats = vo.seats;
      const winnerIds = new Set(vo.winnerIds); // 使用Set来快速查找赢家
      const userId = this.userId;
      let newSeats = [];
      let totalBoxPriceAll = 0; // 用于累积所有玩家的总价格

      // 按玩家分组处理战斗结果
      const fightResult = new Map();
      for (const seat of seats) {
        const isWinner = winnerIds.has(seat.playerId);
        seat.isWinner = isWinner;

        let playerOwnList = [];
        let totalBoxPrice = 0;
        if (winnerIds.size > 1) {
          playerOwnList = fightRes.filter(
            (record) => record.userId === seat.playerId
          );
        } else {
          // 判断是不是赢家
          if (isWinner) {
            playerOwnList = fightRes.filter((record) => record.boxId != null);
          } else {
            playerOwnList = fightRes.filter(
              (record) => record.userId === seat.playerId
            );
          }
        }

        // 计算赢家的总价格
        totalBoxPrice = playerOwnList.reduce(
          (sum, record) => sum + (parseFloat(record.ornamentsPrice) || 0),
          0
        );
        // 计算输家的 lossOrnamentsPrice（仅当当前用户是输家时）
        let winTotalBoxPrice = 0;
        if (isWinner) {
          winTotalBoxPrice = totalBoxPrice;
        } else {
          const lossRecords = playerOwnList.filter(
            (record) => record.boxId == null
          );
          winTotalBoxPrice = lossRecords.reduce(
            (sum, record) => sum + (parseFloat(record.ornamentsPrice) || 0),
            0
          );
        }

        // 累积所有玩家的总价格
        totalBoxPriceAll += totalBoxPrice;

        // 更新座位信息
        if (winnerIds.size == 1 && isWinner) {
          console;
          const playerOwnList = fightRes.filter(
            (record) => record.userId === seat.playerId
          );
          // 计算赢家的总价格
          const totalBoxPrice = playerOwnList.reduce(
            (sum, record) => sum + (parseFloat(record.ornamentsPrice) || 0),
            0
          );
          Object.assign(seat, {
            awardTotalPrices: totalBoxPrice.toFixed(2),
            winTotalBoxPrice: parseFloat(winTotalBoxPrice.toFixed(2)),
          });
        } else {
          Object.assign(seat, {
            awardTotalPrices: totalBoxPrice.toFixed(2),
            winTotalBoxPrice: parseFloat(winTotalBoxPrice.toFixed(2)),
          });
        }

        newSeats.push(seat);
        fightResult.set(seat.playerId, playerOwnList);
      }

      // 更新组件状态
      this.fightResult = fightResult;
      this.winnerId = vo.WinnerId;
      this.seats = newSeats;
      vo.seats = newSeats;

      // 计算 boxPriceTotal
      this.fightRoom = {
        boxData: vo.boxData,
        boxPriceTotal: vo.boxPriceTotal.toFixed(2), // 使用累积的总价格
        // boxPriceTotal: totalBoxPriceAll.toFixed(2), // 使用累积的总价格
        seats: vo.seats,
        winnerIds: vo.winnerIds,
        status: 2,
        model: vo.model,
        playerNum: vo.playerNum,
        roundNumber: vo.roundNumber,
        boxSequence:vo.boxSequence
      };
      // console.log("fightResult", this.fightRoom);

      // 判断是否结束抽奖
      if ([2, 3].includes(this.fightRoom.status)) {
        this.lotteryEnd = true;
      }

      // 处理对战结果
      if (type == "over") {
        // if (true) {
        // console.log(winnerIds, userId, "计算结束");
        // const userId = 145;
        const isWinner = winnerIds.has(userId);

        // 根据玩家数量和赢家数量分配饰品
        switch (true) {
          case vo.playerNum === 2 && winnerIds.size > 1:
            console.log("两人游戏且有超过一个赢家时，各自统计饰品价格");
            // 两人游戏且有超过一个赢家时，各自统计饰品价格
            this.skinsInfo = fightRes.filter((item) => item.userId === userId);
            this.isActive = this.skinsInfo.length;
            break;

          case vo.playerNum === 3 && winnerIds.size === 1:
            console.log(" 三人游戏且只有一个赢家时，赢家拿所有饰品");
            // 三人游戏且只有一个赢家时，赢家拿所有饰品
            if (isWinner) {
              this.skinsInfo = fightRes.filter((item) => item.boxId != null);
            } else {
              this.skinsInfo = fightRes.filter(
                (item) => item.boxId == null && item.userId == userId
              );
            }
            this.isActive = this.skinsInfo.length;
            break;

          case vo.playerNum === 3 && winnerIds.size === 2:
            console.log(
              " 三人游戏且有两个赢家时，赢家拿回自己的所有饰品，输家拿回自己 boxId == null 的饰品"
            );
            // 三人游戏且有两个赢家时，赢家拿回自己的所有饰品，输家拿回自己 boxId == null 的饰品
            this.skinsInfo = fightRes.filter(
              (item) =>
                (isWinner && item.userId === userId) ||
                (!isWinner && item.userId === userId && item.boxId == null)
            );
            this.isActive = this.skinsInfo.length;

            // 如果当前用户是输家，计算其 boxId == null 的饰品总价格
            if (!isWinner) {
              const lossOrnamentsPrice = this.skinsInfo.reduce(
                (sum, record) => sum + (parseFloat(record.ornamentsPrice) || 0),
                0
              );
              this.lossOrnamentsPrice = parseFloat(
                lossOrnamentsPrice.toFixed(2)
              );
              console.log("lossOrnamentsPrice", this.lossOrnamentsPrice);
            }
            break;

          case vo.playerNum === 3 && winnerIds.size === 3:
            console.log("三人平局，各自拿回自己的所有饰品");
            // 三人平局，各自拿回自己的所有饰品
            this.skinsInfo = fightRes.filter((item) => item.userId === userId);
            this.isActive = this.skinsInfo.length;
            break;

          default:
            // 其他情况，按是否为赢家分配饰品
            console.log("其他情况，按是否为赢家分配饰品111", isWinner);
            this.skinsInfo = isWinner
              ? fightRes.filter((item) => item.boxId != null)
              : fightRes.filter((item) => item.boxId == null);
            this.isActive = this.skinsInfo.length;

            // 如果当前用户是输家，计算其 boxId == null 的饰品总价格
            if (!isWinner) {
              const lossOrnamentsPrice = this.skinsInfo.reduce(
                (sum, record) => sum + (parseFloat(record.ornamentsPrice) || 0),
                0
              );
              this.lossOrnamentsPrice = parseFloat(
                lossOrnamentsPrice.toFixed(2)
              );
              console.log("lossOrnamentsPrice", this.lossOrnamentsPrice);
            }
            break;
        }
        if (this.isInclude(this.seats, this.userId)) {
          this.showBoxResult = true;
        }
      }
    },
    // 版本2
    // battleResultDataFn(vo, type = "other") {
    //   // 整理战斗结果数据
    //   const fightRes = vo.fightResult;
    //   const seats = vo.seats;
    //   const winnerIds = new Set(vo.winnerIds); // 使用Set来快速查找赢家
    //   const userId = this.userId;
    //   let newSeats = [];

    //   // 按玩家分组处理战斗结果
    //   const fightResult = new Map();
    //   for (const seat of seats) {
    //     const isWinner = winnerIds.has(seat.playerId);
    //     seat.isWinner = isWinner;

    //     const playerOwnList = fightRes.filter(
    //       (record) => record.userId === seat.playerId
    //     );
    //     const totalBoxPrice = playerOwnList.reduce(
    //       (sum, record) => sum + (record.ornamentsPrice || 0),
    //       0
    //     );
    //     const winTotalBoxPrice = isWinner ? totalBoxPrice : 0; // 如果不是赢家，赢取的总价格为0

    //     // 更新座位信息
    //     Object.assign(seat, {
    //       awardTotalPrices: totalBoxPrice.toFixed(2),
    //       winTotalBoxPrice: winTotalBoxPrice.toFixed(2),
    //     });

    //     newSeats.push(seat);
    //     fightResult.set(seat.playerId, playerOwnList);
    //   }

    //   // 更新组件状态
    //   this.fightResult = fightResult;
    //   this.winnerId = vo.WinnerId;
    //   this.seats = newSeats;
    //   vo.seats = newSeats;

    //   this.fightRoom = {
    //     boxData: vo.boxData,
    //     boxPriceTotal: vo.boxPriceTotal,
    //     seats: vo.seats,
    //     winnerIds: vo.winnerIds,
    //     status: 2,
    //     model: vo.model,
    //     playerNum: vo.playerNum,
    //     roundNumber: vo.roundNumber,
    //   };

    //   // 判断是否结束抽奖
    //   if ([2, 3].includes(this.fightRoom.status)) {
    //     this.lotteryEnd = true;
    //   }

    //   // 处理对战结果
    //   if (type === "over") {
    //     const isWinner = winnerIds.has(userId);
    //     const filteredFightRes = fightRes.filter((item) => item.boxId !== null);
    //     const filteredLossRes = fightRes.find((item) => item.boxId == null);

    //     // 根据玩家数量和赢家数量分配饰品
    //     switch (true) {
    //       case vo.playerNum === 2 && winnerIds.size > 1:
    //         // 两人游戏且有超过一个赢家时，各自统计饰品价格
    //         this.skinsInfo = [].concat(...filteredFightRes);
    //         this.isActive = this.skinsInfo.length;
    //         break;

    //       case vo.playerNum === 3 && winnerIds.size === 1:
    //         // 三人游戏且只有一个赢家时，赢家拿所有饰品
    //         this.skinsInfo = filteredFightRes;
    //         this.isActive = filteredFightRes.length;
    //         break;

    //       case vo.playerNum === 3 && winnerIds.size === 2:
    //         // 三人游戏且有两个赢家时，赢家拿回自己的饰品，输家拿到饰品的价格
    //         this.skinsInfo = isWinner
    //         ? filteredFightRes.filter((item) => item.userId === userId)
    //         : [filteredLossRes];
    //         cosnole.log("case3",  this.skinsInfo);
    //         this.isActive = this.skinsInfo.length;
    //         break;

    //       case vo.playerNum === 3 && winnerIds.size === 3:
    //         // 三人平局，各自拿回自己的饰品
    //         this.skinsInfo = filteredFightRes.filter(
    //           (item) => item.userId === userId
    //         );
    //         this.isActive = this.skinsInfo.length;
    //         break;

    //       default:
    //         // 其他情况，按是否为赢家分配饰品
    //         this.skinsInfo = isWinner ? filteredFightRes : [filteredLossRes];
    //         this.isActive = this.skinsInfo.length;
    //         break;
    //     }

    //     this.showBoxResult = true;
    //   }
    // },
    // 版本1
    // battleResultDataFn(vo, type = "other") {
    //   // 整理数据
    //   let fightRes = vo.fightResult;

    //   // 结果集按人分组
    //   let fightResult = new Map();
    //   let seats = vo.seats;

    //   let newSeats = [];
    //   for (let index = 0; index < seats.length; index++) {
    //     const seat = seats[index];
    //     if (vo.winnerIds.includes(seat.playerId)) {
    //       seat.isWinner = true;
    //     } else {
    //       seat.isWinner = false;
    //     }

    //     let playerOwnList = [];
    //     let totalBoxPrice = 0;
    //     let winTotalBoxPrice = 0;
    //     for (let record of fightRes) {
    //       if (record.userId == seat.playerId) {
    //         playerOwnList.push(record);
    //         if (record.boxId !== null) {
    //           // console.log(record,'循环信息')
    //           totalBoxPrice += record.ornamentsPrice || 0;
    //         }
    //       }

    //       // 判断是不是赢家
    //       if (seat.isWinner) {
    //         winTotalBoxPrice += record.ornamentsPrice || 0;
    //       } else {
    //         if (record.boxId == null) {
    //           // console.log(record,'循环信息')
    //           winTotalBoxPrice += record.ornamentsPrice || 0;
    //         }
    //       }
    //     }
    //     // 更新 seat 中的 awardTotalPrices
    //     seat.awardTotalPrices = totalBoxPrice.toFixed(2);
    //     seat.winTotalBoxPrice = winTotalBoxPrice.toFixed(2);
    //     newSeats.push(seat);
    //     fightResult.set(seat.playerId, playerOwnList);
    //   }
    //   this.fightResult = fightResult;
    //   console.log("fightResult", fightRes, this.userId);
    //   this.winnerId = vo.WinnerId;
    //   this.seats = newSeats;
    //   vo.seats = newSeats;
    //   this.fightRoom = {
    //     boxData: vo.boxData,
    //     boxPriceTotal: vo.boxPriceTotal,
    //     seats: vo.seats,
    //     winnerIds: vo.winnerIds,
    //     status: 2,
    //     model: vo.model,
    //     playerNum: vo.playerNum,
    //     roundNumber: vo.roundNumber,
    //   };
    //   if (this.fightRoom.status == 2 || this.fightRoom.status == 3) {
    //     this.lotteryEnd = true;
    //   }
    //   // 处理对战结果
    //   const userId = this.userId;
    //   // const userId = 79;
    //   const winnerIds = Array.from(vo.winnerIds); // 或者使用 [...vo.winnerIds]
    //   // const winnerIds = Array.from(['78','79']); // 或者使用 [...vo.winnerIds]
    //   const isWinner = winnerIds.includes(userId);
    //   const filteredFightRes = fightRes.filter((item) => item.boxId !== null);
    //   const filteredLossRes = fightRes.find((item) => item.boxId == null);
    //   if(type == 'over'){
    //   // 判断赢家数量
    //   如果vo.playerNum==2的时候，判断vo.winnerIds是不是大于1，如果是就统计各自饰品的价格，如果vo.playerNum==3的时候，判断vo.winnerIds是不是等于1，如果是就赢家拿到所有的饰品，如果等于2，就两个赢家拿回自己的饰品，输家拿到饰品的价格，如果等于3，也就是三个都是平局情况，那么就各自拿回自己的饰品
    //   if (winnerIds.length == 1) {
    //     if (isWinner) {
    //       this.skinsInfo = [].concat(...filteredFightRes);
    //       this.isActive = this.skinsInfo.length;
    //     } else {
    //       this.skinsInfo = [filteredLossRes];
    //       this.isActive = 1;
    //     }
    //   } else if (winnerIds.length > 1) {
    //     const userSkins = fightRes
    //       .flat()
    //       .filter((item) => item.userId == userId&&item.boxId !== null);
    //     this.skinsInfo = userSkins;
    //     this.isActive = userSkins.length;
    //   }
    //   // console.log('this.skinsInfo',this.skinsInfo)
    //   // console.log('this.isActive',this.isActive)
    //   this.showBoxResult = true;
    //   // console.log("this.skinsInfo", this.skinsInfo);
    //   // console.log("this.isActive", this.isActive);
    //   }
    //   // console.log(this.seats);

    //   // this.seatRefresh = new Date();

    //   //console.log("res===");
    //   //console.log(JSON.stringify(fightResult.get(31)));
    // },
    // 处理对战中的数据
    getFightResult(vo) {
      // 整理数据
      let fightRes = vo.fightResult;
      let fightBox = vo.fightBoxVOList;

      // 结果集补充宝箱信息
      for (let record of fightRes) {
        for (let box of fightBox) {
          if (record.boxId == box.boxId) {
            record.boxInfo = box;
            break;
          }
        }
      }

      // 结果集按人分组
      let fightResult = new Map();
      let battleResult = [];
      let seats = vo.fight.seats;

      let newSeats = [];
      for (let index = 0; index < seats.length; index++) {
        const seat = seats[index];
        seat.isWinner = vo.winnerIds.includes(seat.playerId);
        newSeats.push(seat);

        // 查找属于当前玩家的所有记录
        let playerOwnList = fightRes.filter(
          (record) => record.userId === seat.playerId
        );

        // 创建玩家对象并添加到结果集中
        battleResult.push({
          playerId: seat.playerId,
          isWinner: seat.isWinner,
          records: playerOwnList,
        });
        fightResult.set(seats[index].playerId, playerOwnList);
      }
      this.battleResultData = battleResult;
      this.fightResult = fightResult;
      this.winnerId = vo.WinnerId;
      this.seats = newSeats;
      vo.fight.seats = newSeats;
      this.fightRoom = vo.fight;
      // console.log("fightResult", this.fightResult);
      // console.log(" this.winnerId", this.winnerId);
      // console.log("seats", this.seats);
      // console.log(" this.fightRoom", this.fightRoom);
      // console.log("获取对战结束的数据", battleResult, fightResult);
      if (this.fightRoom.playerNum == 2) {
        this.winner_owner = [[], []];
      } else if (this.fightRoom.playerNum == 3) {
        this.winner_owner = [[], [], []];
      }

      this.getOpenProducts();

      // if (this.fightRoom.status == 2 || this.fightRoom.status == 3) {
      //   this.lotteryEnd = true;
      // }
      // this.isready = true;
      // this.seatRefresh = new Date();
    },
    // 计算用户各自饰品的金额
    getOwnPrice(item) {
      let total = 0;
      item.forEach((item) => {
        total += item.ornamentsPrice;
      });
      return total;
    },

    playAudio() {
      this.$store.commit("playAudio");
    },
    getBoxDetail(boxId) {
      this.boxDetail.flag = true;
      this.boxDetail.boxId = boxId;
    },
    handleCreat() {
      let boxObj = {};
      let key;
      for (key in this.fightRoom.boxData) {
        boxObj[key] = this.fightRoom.boxData[key].number;
      }
      createFight({
        boxIdAndNumber: boxObj,
        model: this.fightRoom.model,
        playerNumber: this.fightRoom.playerNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.copy = false;
          // 提示
          this.$message({
            duration: 1000,
            type: "success",
            message: "创建成功",
            customClass: "log_success",
          });

          // 跳转
          this.$router.replace({
            name: "battleroom",
            query: {
              id: res.data.data.id,
              uid: this.userId,
            },
          });
          this.$router.go(0);
        } else {
          this.$message({
            duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      });
    },
    onMyAllEnd() {
      this.allEndNumber++;
      console.log("每次结束");
      if (this.allEndNumber == this.seats.length) {
        setTimeout(() => {
          this.flag = false;
          this.fightRoom.status = 2;
          Gameover(this.fightRoom.id).then(() => {});
        }, 1000);
      }
    },
    onSpeedChange(speed) {
      this.debugSpeed = speed;
    },
    resLocationChange(locationMap) {
      this.resultLocation = locationMap;
    },
    roomIsFull(seats) {
      let flag = true;
      for (let index = 0; index < seats.length; index++) {
        let seat = seats[index];
        if (seat.status == "0" || seat.status == "1") {
          flag = false;
          break;
        }
      }
      return flag;
    },
    roomIsReady(seats) {
      let flag = true;
      for (let index = 0; index < seats.length; index++) {
        let seat = seats[index];
        if (seat.status != "2") {
          flag = false;
          break;
        }
      }
      return flag;
    },
    //建立ws连接
    connectWs() {
      let fid = this.$route.query.id;
      let uid = this.$route.query.uid;
      this.$sockets = new WebSocket(
        bsurl.BASE_API + "/ws/fight/room/" + uid + "/" + fid
      );

      this.$sockets.onopen = () => {
        //console.log("fightRoom ==> onopen");
      };

      this.$sockets.onmessage = (event) => {
        //console.log("fightRoom ==> onmessage", event);

        let msg = JSON.parse(event.data);
        // 判断消息类型
        if (msg.key == "FIGHT_ROOM_INFO") {
          // 房间信息
          let fight = msg.data;
          let seats = fight.seats;
          this.fightRoom = fight;
          this.seats = seats;
          if (fight.winnerIds) {
            this.winnerIds = fight.winnerIds;
          }
          // 计算箱子数量
          // const boxData = this.boxDataArray(fight.boxData);
          // this.fightRoom.boxNumber = this.getBoxNumber(boxData);

          // 如果所有人已就绪，直接开始
          console.log(" everyone is ready");
          if (this.roomIsReady(seats)) {
            console.log(" everyone is ready222", seats);
            this.fightBegin();
          }
        } else if (msg.key == "FIGHT_RESULT") {
          if (msg.data.currentRound) {
            this.currentRound = msg.data.currentRound;
          }
          // 处理对战结果
          this.getFightResult(msg.data);
          if (msg.data.fight.status == 1) {
            this.flag = true;
          } else if (msg.data.fight.status == 2 || msg.data.fight.status == 3) {
            this.flag = false;
          }
        }
      };
      this.$sockets.onclose = () => {
        if (this.fightRoom.status == 0) {
          this.$sockets = new WebSocket(
            bsurl.BASE_API + "/ws/fight/room/" + uid + "/" + fid
          );
        } else {
          this.roomList = [];
        }
      };
    },
    //开启横线
    handleflag() {
      this.flag = true;
    },
    //关闭横线
    closeflag() {
      this.flag = false;
    },
    //整理数据
    // fun(vo) {
    //   // 整理数据
    //   let fightRes = vo.fightResult;
    //   // 结果集按人分组
    //   let fightResult = new Map();
    //   let seats = vo.seats;

    //   let newSeats = [];
    //   for (let index = 0; index < seats.length; index++) {
    //     if (vo.winnerIds.includes(seats[index].playerId)) {
    //       seats[index].isWinner = true;
    //     } else {
    //       seats[index].isWinner = false;
    //     }

    //     let playerOwnList = [];
    //     for (let record of fightRes) {
    //       if (record.userId == seats[index].playerId) {
    //         playerOwnList.push(record);
    //       }
    //     }
    //     newSeats.push(seats[index]);

    //     fightResult.set(seats[index].playerId, playerOwnList);
    //   }
    //   this.fightResult = fightResult;
    //   this.winnerId = vo.WinnerId;
    //   this.seats = newSeats;
    //   vo.seats = newSeats;
    //   this.fightRoom = {
    //     boxData:vo.boxData,
    //     boxPriceTotal:vo.boxPriceTotal,
    //     seats:vo.seats,
    //     winnerIds:vo.winnerIds,
    //     status:2,
    //     model:vo.model,
    //     playerNum:vo.playerNum
    //   };
    //   console.log('房间信息数据',this.fightRoom)
    //   if (this.fightRoom.status == 2 || this.fightRoom.status == 3) {
    //     this.lotteryEnd = true;
    //   }
    // },
    //准备游戏
    seatReady() {
      this.isjoin = true;
    },

    //开始游戏
    fightBegin() {
      // this.$store.commit("stopGlobalMusic");
      let fid = this.$route.query.id;
      Playthegame(fid).then((res) => {
        console.log("开始游戏", res);
        if (res.data.code == 200) {
          this.$soundPlay("opFail");
          this.battleStatus = 1;
          this.$message({
            duration: 1000,
            type: "success",
            message: " 游戏开始",
            customClass: "log_success",
          });
        } else {
          this.$message({
            duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      });
    },

    formatter(value) {
      // 格式化函数，可以根据需要自定义
      return value.toFixed(2); // 格式化为本地数字字符串
    },
    Ready(fid) {
      ApiSeatReady(fid).then((res) => {
        if (res.data.code == 200) {
          getUserInfo().then((res) => {
            this.$store.commit("USER_INFO", res.data.data);
          });

          this.isjoin = false;
        } else {
          console.log("准备失败", res);
          this.verifyReady(fid);
        }
      });
    },
    //确定准备
    verifyReady() {
      if (this.fightRoom.userId == this.userId) {
        this.$message({
          duration: 1000,
          message: "不能加入自己的对战",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      joinFightverify({ fightId: this.$route.query.id }).then((res) => {
        if (res.data.code == 200) {
          let fid = this.$route.query.id;
          this.Ready(fid);
        } else {
          this.$message({
            duration: 1000,
            type: "warning",
            message: res.data.msg,
            customClass: "log_warning",
          });
        }
      });
    },

    ///  复制分享链接
    async handlecopy() {
      const url = window.location.href; // 获取当前地址栏的URL
      const textarea = document.createElement("textarea");
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      // 执行复制操作
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          // 复制成功，使用 Element UI 的 $message 显示通知
          this.$message({
            duration: 1000,
            message: "复制成功",
            type: "success",
            customClass: "log_success",
          });
        } else {
          // 复制失败，显示错误信息
          this.$message({
            duration: 1000,
            message: "浏览器版本过低,请升级浏览器",
            type: "warning",
            customClass: "log_warning",
          });
        }
      } catch (err) {
        this.$message({
          duration: 1000,
          message: "浏览器版本过低,请升级浏览器",
          type: "warning",
          customClass: "log_warning",
        });
      }

      // 移除textarea元素
      document.body.removeChild(textarea);
    },
    async init() {
      // 0 等待中 1 对战中 2 结束
      // 请求api获取用户信息
      await getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.userId = res.data.data.userId;
          this.$store.commit("USER_INFO", res.data.data);
          // 建立ws连接
        } else {
          this.$message({
            duration: 1000,
            message: "获取用户信息失败，请重新登录",
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
      this.battleStatus = this.$route.query.battleStatus;
      console.log("进入房间", this.$route.query);
      switch (Number(this.battleStatus)) {
        case 0:
          // this.connectWs();
          this.getAudience();
          break;
        case 1:
          this.getAudience();
          break;
        case 2:
          this.getFightDetail();
          break;
        default:
          break;
      }
    },
  },
  destroyed() {},

  beforeCreate() {},
  created() {
    this.$bus.$on("num", (data) => {
      this.num = data;
    });
    // 请求api获取用户信息
    getUserInfo().then((res) => {
      if (res.data.code == 200) {
        this.userId = res.data.data.userId;
        this.$store.commit("USER_INFO", res.data.data);
        // 建立ws连接
      } else {
        this.$message({
          duration: 1000,
          message: "获取用户信息失败，请重新登录",
          type: "warning",
          customClass: "log_warning",
        });
      }
    });
  },
  mounted() {
    this.init();
  },
  activated() {
    this.init();
  },
  beforeDestroy() {
    if (this.battleStatus != 2) {
      this.$sockets.close();
    }
    // this.$soundStop("boxAnimBattle");
  },
};
</script>

<style lang="scss" scoped>
// 新的
.van-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.battle-detail {
  --head-height: 14 * 4.2px;
}

.battle-room {
  color: #fff;
  height: 100vh;
}

.battle-room .detail-content {
  position: relative;
  height: 100%;
}

.battle-room .detail-content .filter-flex {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  height: calc(100vh - var(--head-height));
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.battle-room .detail-content .filter-flex .info-box {
  position: relative;
  height: 28 * 4.2px;
}

.battle-room .detail-content .filter-flex .info-box .info-inner {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 26.8 * 4.2px;
  padding: 8 * 4.2px 0 0 0;
  // margin: 0 0 0 1.6 * 4.2px;
  margin: 0px  1.6 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/room_bg1.png");
}

.battle-room .detail-content .filter-flex .info-box .info-bg1 {
  position: absolute;
  top: 3.33 * 4.2px;
  left: 20.8 * 4.2px;
  width: 54.93 * 4.2px;
  height: 1.73 * 4.2px;
  background-repeat: no-repeat;
  background-position: left -0.67 * 4.2px center;
  background-size: 108 * 4.2px 100%;
  background-image: url(data:image/png;base64,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*4.2pxYfdZvjMb5lPa92nQM0nJvOJCnyi5Ifng5OJBM+H9Mh86gQ+0FOaMR9F9ykqmmySz2uG+FSn+axKdx+Bj6fGkyM+8GOMDyfw4ZwSH06r+8h8GON82I7MJ88on5Vt1X1eatp9FHygJybyiYh8oCfNR+4+JRp8Ko3yceSYz0aRz3v0nCPy8aT5eEQ+ZZnzWQA/Ap/N8CNMni09eVjSwuQp+HBi9+EqOI4zwocxyIdV8bH9J3zY9tx95BlQ8qk1xecnbT6xsMgnKnWfaEDkE46hN/F8YpFAJKrmUzrtdZ5PiZLPzNb5uGn3llH3mWKQzxTwqW6ZTyqV8hh8dWCQz2qRz2YNPi4VH+zYuOZ8FJs3v8hnehM+jJqPU6P7sP/zUXcfbT6vIH1ZXy/xgR5p82aUT0ziE03zgSSeTwRNR+ATiQQCAYFPnZpPSYnJ7uN2p7uPI9d8NmxV8ZmRyk+l5O7jyb77LBD5vP8H/Ih8bDrdh2nSfZwCH07VfaanXx0Y5RPX4GPrQHzy9LuPT+KzxiyfSa3yCfB8AlQCHyqRTzQk8KlT8CnV41Op330c7ow2b1PsbcMnlcoX+GAbJ/Epy4LPAokP/IwS+djEyfNq8MEjj8SnQo+PP3s+s3LHx7qN8PHq8VmfBZ9wWMUnhFLzwUFzfPS7DyqzzZtRPnZtPsKrgxkkROBTZpTP4lb4jOX5NMKPzMemwwfbN4lPhfjsg/2cDh/OIJ+4io+V/Gz/fOaa5AM/Ip/6LPiE5WefQJpPiOcTwDZO5BNS8GmY8BnSJ9BT+qnM5wuJT5WR7kP1sfTiumi2GT72rPiI3Qc+JD4oXT5LDPAphx+RD/w05+PS7j4CnwqDfLQ/91HzIT+qN2/w01G6T3/Dmzc9PsHW+CQEPjGZT1TBJynwCQWiIYEPHUuKfBpEPqUt8Jlpgs8c4DHLx26Ez0i7XeazYaMOn/x8LT75JvmUS3zWafDxaj77KPhUtMyHUXzuw2TIx5Y7PlYFH7Ydbt40ZkDis6Yt+KS7D/So+NA2TuITMsmnylD3cTiafOsgN3y2Nv/cp635LIcfiU+jyIfV4wMqXIWaDyfw4WQ+jOJbBxyXMR+s8o7JR+Ppc75f4rOS5/PNevJjbPMmf2ya0OOTTCZlPiGZT53Ap8EYn0p19/mhhc1bmo/bEB+7WT4bVHyKZT7FsKLDZ6lZPvDDr+3xLGtz6XYfPT6cmg+nx8ep5BPn1zary8e6/fHRevZxmeKzRYNPoRafhJoP9IRa5oNDST0+iyQ+VS1v3jT4zOF7jjaffwFtgn28VP72AAAAAABJRU5ErkJggg==);
  -webkit-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}

@-webkit-keyframes infoBgLoopKf01 {
  0% {
    background-position: left -415px center;
  }

  100% {
    background-position: left 0 center;
  }
}

@keyframes infoBgLoopKf01 {
  0% {
    background-position: left -415px center;
  }

  100% {
    background-position: left 0 center;
  }
}

.battle-room .detail-content .filter-flex .info-box .info-id {
  position: absolute;
  top: 2.53 * 4.2px;
  right: 11.33 * 4.2px;
  width: 24 * 4.2px;
  height: 2.4 * 4.2px;
  line-height: 2.4 * 4.2px;
  text-align: center;
  font-size: 2.27 * 4.2px;
  color: #44486a;
}

.battle-room .detail-content .filter-flex .info-box .round-info {
  position: absolute;
  top: 3.33 * 4.2px;
  left: 8.67 * 4.2px;
  width: 16 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  text-align: center;
  font-family: "Alimama ShuHeiTi", serif;
  font-weight: 700;
}

.battle-room .detail-content .filter-flex .info-box .round-info .round-ic {
  float: left;
  width: 2.93 * 4.2px;
  height: 2.4 * 4.2px;
  margin: 1.07 * 4.2px 0 0 0.27 * 4.2px;
}

.battle-room .detail-content .filter-flex .info-box .amount-info {
  position: absolute;
  top: 3.33 * 4.2px;
  left: 31.73 * 4.2px;
  width: 16.53 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-family: "Alimama ShuHeiTi", serif;
  font-weight: 700;
}

.battle-room .detail-content .filter-flex .info-box .amount-info .coin {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
}

.battle-room .detail-content .filter-flex .info-box .box-list {
  position: relative;
  height: 17.33 * 4.2px;
  padding: 0 8 * 4.2px;
  background: rgba(47, 63, 96, 0.1);
}

.battle-room .detail-content .filter-flex .info-box .box-list .swiper-box {
  height: 100%;
  padding-top: 8.8px;
  padding-left: 0.67 * 4.2px;
}

.battle-room .detail-content .filter-flex .info-box .box-list .banner-action {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 6.67 * 4.2px;
  color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 14.67 * 4.2px;
  z-index: 100;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-action
  .svg-icon {
  padding: 0.67 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-action
  .svg-icon:hover {
  -webkit-border-radius: 3.33 * 4.2px;
  border-radius: 3.33 * 4.2px;
  background: rgba(150, 150, 150, 0.5);
}

.battle-room .detail-content .filter-flex .info-box .box-list .banner-last {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 6.67 * 4.2px;
  color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 14.67 * 4.2px;
  z-index: 100;
  left: 4.67 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-last
  .svg-icon {
  padding: 0.67 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-last
  .svg-icon:hover {
  -webkit-border-radius: 3.33 * 4.2px;
  border-radius: 3.33 * 4.2px;
  background: rgba(150, 150, 150, 0.5);
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-last
  .svg-icon {
  -webkit-transform: rotateZ(180deg);
  -ms-transform: rotate(180deg);
  transform: rotateZ(180deg);
}

.battle-room .detail-content .filter-flex .info-box .box-list .banner-next {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 6.67 * 4.2px;
  color: rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 14.67 * 4.2px;
  z-index: 100;
  right: 5.33 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-next
  .svg-icon {
  padding: 0.67 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-next
  .svg-icon:hover {
  -webkit-border-radius: 3.33 * 4.2px;
  border-radius: 3.33 * 4.2px;
  background: rgba(150, 150, 150, 0.5);
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .banner-next
  .svg-icon {
  -webkit-transform: rotateZ(0deg);
  -ms-transform: rotate(0deg);
  transform: rotateZ(0deg);
}

.battle-room .detail-content .filter-flex .info-box .box-list .sel-item {
  display: inline-block;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  margin: 0.4 * 4.2px 1.33 * 4.2px 0 0;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 1s;
  transition: -webkit-transform 1s;
  -o-transition: transform 1s;
  transition: transform 1s;
  transition: transform 1s, -webkit-transform 1s;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .sel-item.sel-item1 {
  margin: 0.4 * 4.2px 1.33 * 4.2px 0 1.33 * 4.2px;
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .sel-item.sel-item-d {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

.battle-room
  .detail-content
  .filter-flex
  .info-box
  .box-list
  .sel-item
  .tag-slide-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.battle-room .detail-content .filter-flex .anim-box {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  height: 100vh;
  // overflow-x: hidden;
  // overflow-y: scroll;
  transition-timing-function: ease-in-out;
  transition-duration: 4s;
  width: 100%;
  // max-width: 430px;
  @media screen and (max-width: 375px) {
    // width: 375px;
  }
  @media screen and (max-width: 390px) {
    // width: 390px;
  }
}

.battle-room .detail-content .filter-flex .anim-box::-webkit-scrollbar {
  width: 0.27 * 4.2px;
  height: 0.27 * 4.2px;
}

.battle-room .detail-content .filter-flex .anim-box::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.battle-room .detail-content .filter-flex .anim-box.anim-box-d {
  overflow-y: hidden;
}

.battle-room .detail-content .filter-flex .anim-box .pk-anim-new {
  position: relative;
}

.battle-room .detail-content .filter-flex .btm-cover {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 14.53 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/app_ft_2.png");
}

.battle-room .room-title {
  position: absolute;
  top: -4 * 4.2px;
  right: 0;
  margin-bottom: 2.67 * 4.2px;
  color: #493b98;
  font-size: 2.4 * 4.2px;
}

.battle-room .pk-anim-box {
  position: absolute;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 26.67 * 4.2px;
  margin: 31.33 * 4.2px 0 0 0;
}

.battle-room .pk-anim-box.pk-anim-box-d {
  margin: 31.47 * 4.2px 0 0 0;
}

.battle-room .pk-anim-box .wait-box {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 20 * 4.2px;
  margin-top: 1.33 * 4.2px;
  background: rgba(21, 16, 41, 0.7);
  background-size: 100% 100%;
}

.battle-room .pk-anim-box .wait-box:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-size: 100% 100%;
}

.battle-room .pk-anim-box .wait-box .wait-anim {
  width: 65.07 * 4.2px;
  height: 26 * 4.2px;
  margin: 0 0 0 17.47 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/wait_anim.gif");
}

.battle-room .anim-ctx {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-top: 0.67 * 4.2px;
  padding: 0 1.33 * 4.2px 13.33 * 4.2px;
}
.text-no-select{
  width: 100%;
}

.battle-room .anim-ctx .user-anim {
  min-height: 150.67 * 4.2px;
  margin: 0 auto;
  background: rgba(29, 42, 51, 0.53);
}

.battle-room .anim-ctx .user-anim .user-content .join-btn {
  margin-top: 4.67 * 4.2px;
  text-align: center;
}

.battle-room .anim-ctx .user-anim .user-content .join-btn .user-join-btn {
  width: 33.33 * 4.2px;
  height: 8.13 * 4.2px;
  line-height: 8.13 * 4.2px;
  font-size: 3.73 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/prize_btn2.png");
}

.battle-room .anim-ctx .user-anim .failed-join {
  height: 8 * 4.2px;
  margin-top: 2 * 4.2px;
}

.battle-room .anim-ctx .user-anim .failed-join .again-btn {
  width: 29.33 * 4.2px;
  height: 7.07 * 4.2px;
  line-height: 7.07 * 4.2px;
  text-align: center;
  font-size: 2.13 * 4.2px;
  color: white;
  background-size: 100% 100%;
}

.battle-room .anim-ctx .user-anim .prod-list {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0.67 * 4.2px 0.53 * 4.2px 6.67 * 4.2px;
  padding-bottom: 20 * 4.2px;
}

.battle-room .anim-ctx .user-anim .prod-list .prize-inner-arr {
  width: 100%;
  transition: all 0.5s ease;
}

.battle-room .anim-ctx .user-anim .prod-list .item-outer {
  position: relative;
  -webkit-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  width: 100%;
  margin: 0 0 1.6 * 4.2px;
  // opacity: 0; /* 初始透明 */
  // transform: translateY(-100%); /* 初始位置在上方 */
  // animation: slideInFromTop 0.5s forwards; /* 应用动画，持续0.5秒，结束后保持最终状态 */
}
@keyframes slideInFromTop {
  from {
    transform: translateY(-100%); /* 从上方开始 */
    opacity: 0; /* 初始透明 */
  }
  to {
    transform: translateY(0); /* 移动到正常位置 */
    opacity: 1; /* 变为不透明 */
  }
}

.battle-room .anim-ctx .user-anim .prod-list .item-outer .index-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 5.07 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #b4c5ff;
  text-align: center;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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);
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item-empty {
  position: relative;
  height: 20.53 * 4.2px;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item {
  position: relative;
  width: 28.67 * 4.2px;
  height: 28.67 * 4.2px;
  margin: 0 auto;
  background-size: 100% 100%;
  background-image: url("../../assets/images/item_bkg1.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg {
  position: absolute;
  top: 2.8 * 4.2px;
  left: 2 * 4.2px;
  width: 24.53 * 4.2px;
  height: 16.8 * 4.2px;
  background-size: 100% 100%;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg.golden {
  background-image: url("../../assets/images/color_golden.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg.red {
  background-image: url("../../assets/images/color_red.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg.purple {
  background-image: url("../../assets/images/color_purple.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg.blue {
  background-image: url("../../assets/images/color_blue.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .prod-tag {
  z-index: 0;
  position: absolute;
  top: 0.67 * 4.2px;
  right: 0.67 * 4.2px;
  width: 11.6 * 4.2px;
  height: 6.27 * 4.2px;
  line-height: 6.27 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: center;
  background-size: 100% 100%;
  background-image: url("../../assets/images/prod-tag.png");
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 19.47 * 4.2px;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-img .prod {
  width: 70%;
  height: 70%;
  margin-top: 2.67 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .level {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #fff;
  text-align: left;
  padding: 0 2.67 * 4.2px;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .title {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #fff;
  text-align: left;
  padding: 0 2.67 * 4.2px;
}

.battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .money {
  height: 9.07 * 4.2px;
  line-height: 9.07 * 4.2px;
  color: #edb375;
  font-size: 3.33 * 4.2px;
  text-align: center;
  width: 100%;
}

.battle-room
  .anim-ctx
  .user-anim
  .prod-list
  .prod-item
  .inner-info
  .money
  .coin {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim
  .prod-list
  .prod-item
  .inner-info
  .money
  .price {
  position: relative;
  font-family: "Alimama ShuHeiTi", serif;
}

.battle-room .anim-ctx .user-anim .user-info {
  position: relative;
  height: 30.13 * 4.2px;
  background-size: 100% 100%;
}

.battle-room .anim-ctx .user-anim .user-info .is-me {
  position: absolute;
  top: 0.4 * 4.2px;
  right: 1.2 * 4.2px;
  width: 6.67 * 4.2px;
  height: 6.67 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAP93Iv92Jv9/Jv9tK/95I/93KP9tCf8AAP99Kf90Iv9+KP+EH/94KP94KP94Jf95Jf/69/95Jv96Jv93JP97LP95JP92Jv92J/94JP94Jv96KP96IP97KP93Jv/UP/94Jv95KP92JP+HPv95Jv97Kf+VVf/UP/92Jf99Kv+NR//59f/z7P+4N/+uNP98Kf96Kf/gzP/dyP/UPv/UP/++l//COv/SPv+bX//Xvv/Lq/9+MP/x6P/RP//28f/v5v/UP/+xgv/UP/+ZW/+IPv/UPv+dYf/j0f/s4v/awv/28v+6kf/TPv+lbv+fZf/j0v/r3//Wu/+bXf/RPv/PPf/erv/Elv+uSv+pdf+vf/+0h//TPf/UP//IqP+5jf+ziP/dyf/UPv/m1//RtP/q3v/SPv+9lf+OR//Or//OPf/Olv+4e/+7XP/Vn//26v/qyP/Dnv/w5//07/+3jP/XwP+RT//o2v+5N//17//KPP+iZv/Qq//FOv+lMv+/Of/IPP+TLP+/fv/MPf+5N//duP/CfP/MYv/s0//Lq//FVP/Mbf+aN//myP+kPP/Ng/+6if/SPv/x6v+1if+ygv/COv/l1P/kuf/CPP/dyP+rcv+qd//JPP/v1v+8Of+oO//Sev++Xv+sQP/ESP/TQP/dwv+eZP/n2f/HRv/////UP35PIYtXI6RmJ45ZJIZUIpFaJIhVI7BtKZpgJphfJaBkJ6trKYFRIYRSIrhyKn9QIYJTJpZeJZ5iJq5sKJBoQLl0K6lnJ8Z3K5NcJINSIrRvKtd6K8uJMIZWKLx2K8B0Kv/QPtCPMcBxKf79/P/s1f36+MaDLrqaffTx7v+/Osm0of/GO9qBLaCCaOHY0JRsROzn4/nLPf/LPNjLwNF7LPjVuL+HTcN/LaWGbPHs6IdcM/vPPo1iOrSBTsy7rtuZMuqhM+WCLf/fp/rj0bmjk7mMX7J8RaZ3SZx6XaJxP7Odi/akNdGHL96LL/7HcfClZf7Icv/amJloOPbz8ciKRNHCtWD5nsMAAACodFJOUwAJEwYEDhkCAQsWGwgMER8g9UIyHFQ1Jyg4Ii8QPkXzO08VYixJbvAkKmny6RURJkzHwtDamRl1PbqmWt1K7OLgjIcyI352y9m+8JWQeUWowbZkyUX2dqGDh49UT2tWSpdv0rLS62FXg2OweJn3/v6f4+uSoyi3IuCbVq5vM3b3FIHhUNO96+ySs/xx7HbjiFrlaHDJsO3quV5p7u6Bm/TBaNFcy27KlnuyqqIAAAXnSURBVEjHfdZ3WBNnHAdwcsldcpfcJSQHZCIj4EXEgBWLihOsWhUQt3XV4t7bqrWuVjtc3Xv+8yZhj4QgIEsDkdEqilptXXXW0b379H3vAkGG9wc8eZ73c7/7vfe+33sDAh5/yaRSqUz2+CEyYYhMGCsRi2hSJJE+RkjECpIUSyRoKE4rxAqcYlkKF0t6FiRDsARDi0UMy2k5gmGIEI3OoMfEPdSRSUg4InWeCsMxTrf1gyiNiuUWpW9YbArpwSBhUL+5Kc1AYGxwxt59y+IMeu3c9JhJkWotppB2J2jCEDcxM2a+hqW49/c2glXbUq2cLmNM4KQ+am1E*4.2pxMFq4mbkRkzOMpCRFiWrW5qanpnl57VqqPHBA7qzvjE2JjBQTqlkdjx7um7d389/dYehjCHRsf7jKSTkAtiSBjH9Nu+8OK38LpzcfIUmuLNuD6hFqqj4WuEzxj7tCCeXeitqispKam/7Z08haQsoX36B46LhkYkeVTM5IXeCIWtrrY4K6uyvOSkrd30jw41UyKpXwSHz0watkYQ*4.2px115VllhYUFRZW1J2xPTCEjtGq/kbWLkT4R+2Rv27HyooLq7OzcowVZ+dAMpZEZFxjPG0m7GL5uTZBOj/OiuKgw15GXl+fIhearjkYN1wFaV4QGiYQgnQqPHS2IbEeOy+USzBXbgNkkBs2gwPiMYJaEhLGqD631izok8lw1Tmfr1auPmMhBgelbOTxAJqYM07b0HY/EwFFQ3PwaXi2XTp1y/wtATjNoRP0MeIbGQkyL08bO2WgMkCmo5PlJS+KCfaL4ARCuU/ZrALgqAIB1TvKG06TOTZTTsAqTMm9RmEFphOL7kuKiH3lwoaXCfgkApwuAFsEcxhlCpSKMCtgLHaGyWlXU5gm8OAr7cAJQYbfb7wPgdl4DjbmCWboTwxgaLRqpmKaUHPfC8728x5BweDylAJwvLS29CgD86/Fk88a7ezvHYjS/1yQiyqqZ9sqL3rpyVAN0vdC81Z488/KKMAtBomUmpfVhu/a9erqqNqsg1+HqhuQ4qsvK63//Yer0OHOECFVhzK+9Dv46W5VfVu3IqXG63XahF/iv1W53u52uvOzCyobj3zWvfGl5Co0IpvlkFfjzbH05Ikj4yS07nOVSV072UURA09RlG/H2Kn/4q9iv84/TCsk1ezOa6c5VUC+HPmrr5Xx7B632C6DxFwB+qhF6OevvRSqiQtCMXew4Y/c98MFa+FUABZqx3+CMmSwEjd6LhMRYvQq+l2/4N3nrfKnb14sHEUHkn/Du3mGVYzTMZxkSKiXBbJ7gM+1vHz4YAB4kiuDKHLF0J2PEYWAHSBVYSmqigaPIgX4Difv6Of4JPUINKGgaI+QUrgiQkkRiWlqGSUuJoLHxawb2U8EDuDDBPwUP4M4c8SVJw8BOTJbjkMhT30ZRACNn4ChoHvI3v3EDgHPOmmb+xxXbiMMiGELqaZuWJGNovxgWv+eLj1hoStCgRldNqdPpynHwBO4WhS+EeCLB9abItviIHd3LdvnyzZ/9e//h5f+QwJV8pOxXc8YA1D+/reOfijITvOmcMANm82IWjJRwjZzkF79gxjxiUI5VC5k0WwRF0Cw+UpS4GKUlrBOijpyEjAEaPvv4tCyrrEUpJkZi/REhUsTC5xkaa7sh+0FTV1teWVmZX3JCEDqfUOKStg86qmOKfC5wQZvxVtU3NDRU3fYiodIFje/bd31QcAeBDMNBE7NgomA+PHMcXnfOTB6qEMSRWZ0EX6fNmCla/vGnq+/da/r7iz24EYqE7gQKGmS2xWRODNMzmGXFVPh5Pfg5i8HOE9atHRneVSADn23I4JjMN7SUkTVNX7n64AEzQZijEtYNh4KlJV2PMsiEBW3YMt8SAcPUNP2zAwYlpUzcPyxpZg+CNyqNac5cFaNAB5IQPWE0svPSk5ZHaXoQyOCESs9ipHDsIRVikkqesyjMLO9JoC8aOiChw5RwuEL3SLEqqZ4FOrHBg5VU5r+FmMbhIesR8T//y+zSdci4MwAAAABJRU5ErkJggg==);
}

.battle-room .anim-ctx .user-anim .user-info .avatar-box .avatar-inner {
  position: relative;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAE4UExURQAAABwpSx0qTBwpTB0oSxUqVRwoTRsqTBwoTBwpTB0pSyAgQAAAVRwpTBozTRwpTSAqShgkSRwoTR0pTDMzMxwpTRwoSxwpTRwcVR0oTQAAABspTCIiRB0oSxomTRwoTBwpTBwpTB4tSxQnThsqTQAAgBwpTB0oTBspSxwpSxwoTBspTCAwUB0qTRwpTBcuRhwpTBwpTBwqTR0pSyQkSRosTxwpTBsqSxwpTB0qTBwoTBwpTBwpSxwpSxwpTABAQBwqTBwqTBspTB0pSyoqVRwoTRwpTRwqTCQkSRspTRwpTBwpTBwpTBspTB0pTBspTB0nTh0pTBwqTBwqTRspSxwqSxwpTBwoTBspSx0pTRwoTRsoURwpTBwpTBwrRxwoShsoSxsoTBwpTBspTRsqTR0oTRomTRwpTBCmyCYAAABndFJOUwDVYe1zDFqN6dmpCAOvCqMYFZJrBbRS5gmFAZYPmBSrwN4RDYwCwnKVpninEHTcC5Sivn0HHcaf5YaR27CcmgSTgKiOBn7B1w5xna65grvDGnysmbptv6SEqrcTs/QSLWax611WWShy4mizAAABMklEQVRIx+3WV1PCQBDA8RU8wWBCQkRAqqBi772hqKCCgr1X1P3+38CCMgm5S+5m9MEZ/8+/udmn3QMwRrLbh9NDrfVGd3VdP3X5gJVPQmvznSw9jLT2OqiaXCK9Vdr7GQlZxa2eJJHdQK5JKyto17F5fiKjffFug46V0KmJvoYekdG5wPc8O0FEfp/h04hLH/Pf3SBvAYDXR+TPA89uAb4AXSEB3vOrfBlevAK8Hdr++U/wItSeBHgLuNx/lz/cCvAxuA8K8EGA6ytuLcfeV0G6zKvHPxdNeopLH5GvNZY44dB50liS2oGjlohhBWtnDjqpmBa8lrJ/O9x0PhIFG+1XLMdJTYlogGo/Q5+HqYdVrdDf3mKcbXWOoidnmJ+C2f3FyEWkd9NTbz0aXdswfSHeAFnDlNUDCteyAAAAAElFTkSuQmCC);
}

.battle-room
  .anim-ctx
  .user-anim
  .user-info
  .avatar-box
  .avatar-inner
  .avatar-mask {
  background-size: 100% 100%;
  background-image: url("../../assets/images/head_bk.png");
}

.battle-room .anim-ctx .user-anim .user-info .avatar-box .avatar-inner .a-img {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.27 * 4.2px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.battle-room .anim-ctx .user-anim .user-info .avatar-box .action-img {
  position: absolute;
  top: 2.67 * 4.2px;
  right: 2.67 * 4.2px;
  width: 8.8 * 4.2px;
  height: 10.27 * 4.2px;
  background-size: 100% 100%;
}

.battle-room .anim-ctx .user-anim .user-info .avatar-box .action-img .img {
  display: inline-block;
  width: 6.13 * 4.2px;
  height: 4.27 * 4.2px;
  margin: 2.13 * 4.2px 0 0 1.47 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.battle-room .anim-ctx .user-anim .user-info .nick-name {
  color: #fff;
  margin-top: 0.93 * 4.2px;
}

.battle-room .anim-ctx .user-anim .user-info .nick-name .nick {
  width: 24.8 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: center;
}

.battle-room .anim-ctx .user-anim .user-info .win-price {
  position: relative;
}

.battle-room .anim-ctx .user-anim .user-info .win-price .user-m-top {
  position: absolute;
  width: 100%;
  font-size: 3 * 4.2px;
  font-weight: 400;
}

.battle-room
  .anim-ctx
  .user-anim
  .user-info
  .win-price
  .user-m-top
  .top-m-anim {
  display: inline-block;
  margin-top: 4px;
  -webkit-animation: userMKfLeft 0.5s ease-in 1;
  animation: userMKfLeft 0.5s ease-in 1;
}

@-webkit-keyframes userMKfLeft {
  0% {
    margin-top: 28px;
    opacity: 0.3;
  }

  100% {
    margin-top: 0;
    opacity: 1;
  }
}

@keyframes userMKfLeft {
  0% {
    margin-top: 28px;
    opacity: 0.3;
  }

  100% {
    margin-top: 0;
    opacity: 1;
  }
}

.battle-room .anim-ctx .user-anim .user-info .win-price .user-m-btm {
  position: absolute;
  width: 100%;
  font-size: 2.93 * 4.2px;
}

.battle-room .anim-ctx .user-anim .user-info .win-price .user-m-btm .btm-m-aim {
  display: inline-block;
  margin-top: 7.97 * 4.2px;
  -webkit-animation: userMKfRight 0.5s ease-in 1;
  animation: userMKfRight 0.5s ease-in 1;
}

@-webkit-keyframes userMKfRight {
  0% {
    margin-top: 56px;
    opacity: 0.5;
  }

  100% {
    margin-top: 56px;
    opacity: 1;
  }
}

@keyframes userMKfRight {
  0% {
    margin-top: 56px;
    opacity: 0.5;
  }

  100% {
    margin-top: 56px;
    opacity: 1;
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .user-info
  .win-price
  .user-m-btm
  .btm-m-aim
  .orig-money {
  opacity: 0.7;
  margin-left: 0.67 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim
  .user-info
  .win-price
  .user-m-btm
  .btm-m-aim
  .orig-money-d {
  text-decoration: line-through;
}

.battle-room .anim-ctx .user-anim .user-info .win-price .coin {
  width: 5.07 * 4.2px;
  height: 5.07 * 4.2px;
  margin-right: 0.53 * 4.2px;
}

.battle-room .anim-ctx .user-anim .user-info .action-box {
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
}

.battle-room .anim-ctx .user-anim .user-info .action-box .user-actions {
  height: 6.13 * 4.2px;
  background: rgba(0, 0, 0, 0.3);
}

.battle-room .anim-ctx .user-anim .user-info .action-box .user-actions image {
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
  margin: 0.67 * 4.2px auto;
}

.battle-room .anim-ctx .user-anim .top-box {
  position: relative;
  height: 24 * 4.2px;
  width: 100%;
  margin: 4.67 * 4.2px 0 2.67 * 4.2px;
  background-size: 100% 100%;
}

.battle-room .anim-ctx .user-anim .top-box .result-box {
  width: 100%;
  height: 100%;
}

.battle-room .anim-ctx .user-anim .top-box .result-box .win-result {
  width: 35.07 * 4.2px;
  height: 15.87 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/win_bg1.png");
}

.battle-room .anim-ctx .user-anim .top-box .result-box .win-result1 {
  position: relative;
  width: 99.666px;
  height: 16.67 * 4.2px;
  background: url("../../assets/images/win_bg3.png") no-repeat top center /
      99.666px 54.894px,
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAXCAMAAADOf8o0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAP/Fpf/IXf/GVf/8+f/bmv/BT//15P/9+f/ksP+1nv/flP/CUP/Vgf/////fpP/////jnv/Pbf/KYf/35//GV//EUv/DUf/NbP/EU//Ma//EUv/EUv/KYf/nuf/z2v/Yjf/Maf/x0f/ovf/GV//FVP/z3f/z3//IWP/EV//GVv/GWP/ZkP/ls//Pdf/FUv/IWv/KZf/Whf/LZP/78//doP/Se//KY//57P/lsf/EVv/iqf/w0//Wif/FU//fpP/DWP/GVP/fof/GVP/89f/14f/FUv/8+f/MZv/GVf/EUf/67//EVP/9+f/Te//Tev/IXv/Whf/Tev/Naf/pvP/ai//KYf/ZmP/lsf/ty//ipv/GVP/w0P/rxv/03v/pvP/24//cmf/alv/tyv/sxv/Xkf/Whv/v0f/w0P/uzf/syP/Rd//iq//Pcv/y2P/ntv/IWv/ntv/z3v/iq//dm//blv/Zkf/25v/syv/lsf/Xiv/pu//14//IXf/89f/v0f/sxv/dnP/hpv/foP/Pcv/JYP/jqv/55f/IXv/jq//FVf/t3P/GV//Vgf/ReP/LZf/UgP/25P/Qcf/FUv/47v/////blf/89v/57f/Vhv/ETv/EUv/Se//Re//Pcv/Pc//JYf/JYv/Qcv/Vhf/Ujf/Pcv/Yj//Pc//dm//hsP/HWf/FUv/JY//Sev/IYP/ou//GWv/GWv/blP/Naf/pu//46//25P/15f/Whv/qxP/35P/Whf/jsP/em//lsP/cmv/w0f/8+v/ou//tx//fpP/v0f/z2v/sx//akP/ipv/Maf/y2v/36//UhP/04v/Rdf/dnP/pu//YkP/78//++v/36//68//FVf/////////9+f/14v/24//47P/47P//+v/9+v/////78//47P/14//JYf/HWf/DUv/EUf/qwf/Yi//89//EUv/dm//78//57P/Whf/ZkP/hpv/FVf/SfP/z2v/Pcv/Maf/HWv/24//JYf/sxv/w0P/lsP/pu//++qp4sbEAAADsdFJOUwACBedRKx3EguABBS0YEBTOCRQEQTr6W0q3ONDnLXOTG9TUHcfzJBMYJFKH6kpa2/kQ4uxzT4Tn+PROkZ+J1qYqcIWkuVCfpIePtB5Br/kur+Xk+i0i+i+oqfdd8Llz8pBXwnPxRqjh7ZFC68uvh6zogqlz+3urhITsdLl5Skrj+m/f6ZuCMTqV1NAdwcrRe4blhntbjNDTadAN3fJu/VCl0/7dL+aPpNsqmoBV28ST4WMrGfG32dT+Snv0uav9kvddhJqYy+OeuHu/8Mu/R16Y2Ph966mp7jyVqbnY6bAw8g/r0/zQ0KuB8ef+R91QPwAABGpJREFUSMellHdUFFcUxi9DXIKL7MIWUIpIbwHBoCggTSGARmNNRI0aY4xRExO7Jhp7RY2JJqb3XjW999577+WP3Znd2TqzLfe9KbsDe07+yHfOvHvf9713f3uYXQAArjMa*4.2pxWQmsnwP5WWSjUY4NfUVDAajd8oyXeRyATaTI5EjkNJZ2en5BefNlA9NHn19Hii0ZkRqi9+hl8iEcDuKgXzFcvKGJY9Dj0sy0r+9exAXUuTCWw8SRh58zmw7G/4sCrmS477wGzeDfATx/0OPRzHyRhuoCTMk1w8SRiOq6+v57h1CRz3oxndzWazuYQklwtER0r2fy8IP+zfjb2EmZgk6Ygg/CG3SR/RZIG8exrPPqVESTSaLwgL4DlBWFcsRDWRYjxEbzV6VGnf6nCP5/347xsTT7HWmu/xDIfNHs/KldFxHoo5Lxh8ZcuWNxuDipZqb14cDM6Nj5mLh9O01gXBYGMx3li/NBi8KD9Ilvz8ZRQTCMzD8nZA1tbX+2ECgcVxKc*4.2px8LwZg7UYecj6xYGtBYDNs0pyaTi8CYuhYFM4/GlBQUn/aY+Gw6fiURJOhYlm5ObmGlQzNyzptfPDqwCwOUNJzg2FXpB4odBe2JWcvJzuDMmyxoZCLyl9cgwG7xHdj486C64IhcZuwBurNjTgTo3ampu38fz25jd2ATTw/Dao4/m9EoaPozlRykLZ0s/h+eVRDM83wLs835aXgMK4DgvAMbus1QBX2+3b4RO7fZGEscfRanVenWLp78NlpmLjjJdhjd3e9mLMrdlwzKnIABfimveZ07mGXjANkjQb3Uq5H/SEMu4ecmVRJS56cq1S+cJtdDrfWbjW6Wxa64zqLrjB4TjY1LTE4XAYIA/XD/EZonnTM9F55vla7ds/B01HrZ4UPdTieqfM2eiQdHiJI6op0Od2HwYY5na70wEOuon6NBNND1Pzklhv9NnEmpYG07AwkEe2N92cQCO3pNE1Q1DYVGHRQ5/Xew1ivF4vYqq8RFWaz72Cel4N5hbi3KsHuBsrA3DrHcSYQqIdXu+Oj1fQoSh0M2kzwuc7CzE+nw8xJ7H4RsT+3k5i7puOy6hYDDmWSY6NwQYxkDkdmxwSvYcJHKJDpYMS5k9RJBhRFNOZnaOwiLP2qOPSp84izkOPiKIGI4q3ldJmDKYEA2W3i2KO7AyDQ6K4Uz4oXkmbv/z+CgCL3+/vuswv67FekjCPF44ku5HlcABXS0uLpbz1gQoSTc2ReeQKI/1xJxUScxwapbCHDkXhTsLsc7msRU*4.2pxl8t1AB9XYjtZ95FkqItqfApAu0vVUM33IxEdRn2N+PTiBQtx2xOJsPkaSyFk2WRld9ts1q4a01HssyiGur0m8hltqrSYbHSYWCPDZiufRM79Y4vRjSrG2tpd1FVGTlqyFIy1e5yJXmY6rNKpovEP/hfmbxPBZFu0mLIUqrITkKL8kE0ZHaS09pbGfK91uhSdrqb/P+nC6upqDab8KAMtHRUZJxhdjEr/BW4bfVPHMCDxAAAAAElFTkSuQmCC)
      no-repeat bottom center / 57.12px 12.894px;
}

.battle-room .anim-ctx .user-anim .top-box .result-box .win-result1 .goods-img {
  width: 14 * 4.2px;
  height: 10.67 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/win_ic1.png");
  margin: 1.33 * 4.2px 0 0 4.8 * 4.2px;
}

.battle-room .anim-ctx .user-anim .top-box .result-box .win-result1 .win-price {
  position: absolute;
  right: 0;
  bottom: 4 * 4.2px;
  width: 18.8 * 4.2px;
  height: 4.13 * 4.2px;
  line-height: 4.13 * 4.2px;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  text-align: right;
  padding: 0 1.07 * 4.2px 0 0;
  color: #ffecd1;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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*4.2pxiWzhyCDGxjDR/NFm7oJl0liIZtBjDg4jpZKuP7JLgoN5l93MpWyNvezMuRxgtxBknhkrgyLjMXeWXUZduEzwzMD5G9E0EGSIWculzB0ZJGVPoy4HspQv6TXGvFeJgEzmj575bJkcgWWS0FrXBsjlD3Pyk+ky6WBmFLGUfd*4.2pxfYpXifmSk4u2n2zhyOsYMjvzpx50kmY+3wgyHyeVoSngK4MWczA9mM0en8QLfeSXYjZ6XZybFZme+YiMMndTmeFmrqMyw/xhMwstB6ccbGxAVlMxzLv80ioxZsa5uaQ8isge+sh0/gbIMgGZ8cwA5GqKPMJVBq7sIlLMvmKX00yeRdbCWcRWiZleNgN/VXLdQ1gmAjL+s5Kb+UbngUHyM1VNKwNlhvkb4pD5uyjbYJUojPyV8DeGaZdnibpqWJJxXSwzvgxwfyZ4Mz8iyDB/IHPxcbw/0YwOdmWQvz/msqEYvMtSYfuZdHmuX1VpnCSDMnsJlZFJ5o9eRlP4m32tBefv4hV6zGn4/YctB/Pny/1icyW3g/6uGi5sesnJRS5bTmyTAcgZ7xBk9v6SkiRUBkHuGfwaflkv/FBeXD/cPkIeM5SJd1W/h4w/j/oYflbV/8zM9PvgQwbkOzHh6qrTKbh3jD+YEfQdw4q9Y/QZvGPMdf6QmCAjsxe3//DJiDTzwD52gD7pgZjZm9GPw8mY81/kxehuxIvp8fHIKCTH56L/+vvvIbvbv2j03xP3f9PpJulrkSN9LZLeufPs9m3yWnSVPBbJbS35PhmOA9r/AZa/38WcgiHYAAAAAElFTkSuQmCC);
}

.battle-room .anim-ctx .user-anim .top-box .result-box .loss-result {
  position: relative;
  width: 99.666px;
  height: 16.67 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/lose_bg1.png");
}

.battle-room .anim-ctx .user-anim .top-box .result-box .loss-result .goods-img {
  width: 16 * 4.2px;
  height: 10.67 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  margin: 1.33 * 4.2px 0 0 3.73 * 4.2px;
}

.battle-room .anim-ctx .user-anim .top-box .result-box .loss-result .loss-name {
  top: 0.27 * 4.2px;
  width: 18.8 * 4.2px;
  height: 3.73 * 4.2px;
  line-height: 3.73 * 4.2px;
  font-size: 2.67 * 4.2px;
  padding: 0 0 0 1.07 * 4.2px;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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*4.2pxZ+CDDHz340/rDrcn3fKo+NazTnbTmC4QCM2+dLJhvtiNmjN+6zzNVzx1yxdHEAmKOYjUCgpCQ3ZAhPIzCYUWhqKKujHk5oJhKaOH+g+UX+ptP52MCa9dWqxloFi/zuhH27b5qN2ooTJkADXVnvB5r5SGMANMuGLkUaz+tA4+6xMRdoohakrU05jTQQzY5QpNkANPaW0Uize5Qd0Oj6BMsN4bMRGLwsDDL8iaNJpDQH/G1zIJubTttjE7AmYy2iDqUJMCHZVGJPHM19pLHisnH3yFtDaIg4U9yuLfnNKItksyGZ0YRQbwToDU8jKBaKg0xXSWVzi2bjnUObig1kNK1IA02pgcf3poLHldb7Gc1dA9LUUqtvgIZkcwGbKoGmylJQG2wqKzSJZFM+xj7axeEYbUpDQ0CyGUZolIvDxUFAg9kIhSSbW9r1+ZgNmavLqDB6A02dAm/QYd6bS9hUQ51UU0Dj6UppsKkjtWll2BTSNJGmKmhTIHEIaQolZtnIyMjUhYstglg2Qok3+XHe3tRiqaaARtLURWIxzvhChd+JxctoNp6upfrZVehNM1icJmUx8SYzmVjM0cCEKykFI81wyEYojrSw4LKRshhmKgctxmyoxUBzJwxnilm8qaUSLb4hZfFjK5ZNtjudqSg6U+1FdKaS2ExhU0BzlNFILF4FNJCNYd9skIY1lcA1hT/AeCmLHXlv+jaVTS0uieKzucrR8DNFaOw0NKRnKoLRDI6ZihAX8t4M/EyxbAbJTElnM/AzZTioZipiMM4UNhUuNBORmapnrybdcWhTWmymuGxe0H3iJG/xfUrTATNVymiaS6JqicXtbtTiPY3gTfLccv7V5Pab/jSyvd5wtJh5AxZXcxOeit6Q7eYiZzHZt3hvOog3vr2b4jYKSTZk*4.2pxFN+QSjNyP7ZKOO2ZjDhNdjU1w2ZKaqeYvjf73NeYM0Xl69/jfYFGZD95tmnPC1KYwGZiqpkdKw/ab/7gczFSn534hE0vtNBpupGv7vhzQ2Ehru70dm6gmdKc/e2xbZb9phFeX+fpk0G95iQd+mLFhTA7/7SWgGw+737p169079n3cqSAxfYWFkZyciRejw1x0cnW9sX+3NYI8Due4KWglPv+uOdkWvOzg3r5c+f02vu2a47shDBeI04e+PXXeWPfx15yyQslhkqAMEwhkiTKV7a/1DUOYNXr5kng4GJqz/k12+OFDws2kLoJdvC7l8V/KXL4cC2rzOvpCXu6arawu7NMnliw+DXiO9fK/0uODl2++degsGZpFJ+r5efAAAAABJRU5ErkJggg==);
}

.battle-room
  .anim-ctx
  .user-anim
  .top-box
  .result-box
  .loss-result
  .loss-price {
  position: absolute;
  right: 0;
  bottom: 4 * 4.2px;
  width: 18.8 * 4.2px;
  height: 4.13 * 4.2px;
  line-height: 4.13 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: right;
  padding: 0 1.07 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI0AAAAfCAMAAADtLr7fAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAACcsSScsSQBVVSoqVTMzTScsSQAAAEBAQCQkSSgoQygtSScnTigsSScsSicsSScsSScsSScsSQAAgCMuRicrSSIzRCYsSCcrSCcsSScsSScsSScsSScsSSAgQC4uRigsSCgtSicsSCcsSScsSScsSScsSTMzMycuRiQrSSYrSCcsSicsSSYsSSgsSScsSScsSSAwTyoqTCQsSSYmSiYrSCgrSCYrSCYtSSgrSicsSScsSSgsSScsSSoqQCkpRyctSScsSCYtSCcsSScsSiUtSSgtSycrSSYtSSksSicsSCctSiYrSScrSigrSScsSScrSScsSSgtSCUrSSYrSiYtSScsSSYrSCYsSScsSCcsSScsSicsSScsSSYvTCYtRikuSyYtRycrSygtSSYsSicsSCgsSScsSS0tSygwSCkpTCgvSiUqSicsSicrSCcsSScsSicsSCcsSScsSSctSicsSScsSScsSScsSScsSSoqSiYsSictSiYuSCYsSSgtSCcsSScrSSgtSSwsTiYmTSYrRycsSCctSSgsSicsSSgsSiQwSSgtSigrSCBAUCYrSScsSicrSScsSScsSScsSScsSScsSSc5VScrSSctSSYrSScsSCYtSicsSicsSSgtSScsSSMsRicuSCYsSScsSScsSSsrRyUqSiUtRyUsRycrSicsSCgsSSgtSScsSSgtSiYsSSYsSSoqVScsSSctSScpRyYsSSgsSictSCctSSYsSScsSCcsSScsSUiAgFVVVSkrSiosSSgrSSsrRyctSykuRykuSScrSSgsSyYtSCcsSicsSjAwUCgsSScsSSYsSyctSicrSigsSScrSScsSicsSSYsSSQ3SSctSSctSCYtSSUtSicsSjMzZigsSigtSScrSScsSigsSicsSScsSigsSgAA/yYqRycrSCYrSictSScrSCksSSgsSSctSSgtSigtSScsSSctSScsSictSSgsSSYsSCktSicuSiguSicsSSgsSictSigsSScuSicsScgBkkIAAAD/dFJOUwDtxAMGCvUBBAcTPw1zisDk7PcCFjsPfnzj8+nm+wgLUo7M6+/8+QUhKlho8IXV4fQQHiMONV9xoIfc8dv4DBmrdXiv1xwzVFBFooOZwoGXvLg5MWRJpGqMqefe0f0bKCw9QWytm3qnESAlJjdWTp6VvsbL9t3y08/7GF1hQ7pmkN/IFxQvLltMYrQVLUcIZW/anc2y4NIJtrGTbqaR2c7qHSeSte4SMERLSFxtlOJas8cMueUaV3lVvdvFdv4CAx8rTSQiMjhCOUrJ0BCu9ilPa0aImILoDom31D40BYCapaO71qroATawoPxwXn59YGO/nq3w9IY+SFm/tMLzb8l8SrMAAAWRSURBVFjD7Zd7ONV3HMcPXWidiNZhpDORaZLb0Q21rVi1trIuWqPNbKm0IjnzxHJpGQ8biUOhZM66oKykC7aEokL36TItUelinlW7pM0+n+/l93PS/zx7fP79/vN63pfP5/lKdIb1032t/6CRA+RTpDKH71/66uUN6w66ux9bXum0Iqe+PCFmXtV15xP*4.2px30Hf/LlzG9qYlfNePXtw8X78h6ExyVGePnlJ90f8uZbS9sevveO7QU9PfPI7wrmzP4subX1ZqZ/86PauykduZ7r5wbpP9MuWRMdvHn7adXVcdO3bZocEpVq98rQosUt2RYGWmpLF6XJE3tDtQRpdJFmilQhW0Zglri7O1pXVgTkjClP2DjPw/lO9fA/geX8XwtqgO*4.2px8d95D36La0+0OZefNGFI6SHjtsZLtpMa9MyzCgIv3kj+feLNhf4fvPFoGoAcaArS19cGjFHbv*4.2pxqW9O3uYZEAcSIxdkWWpaPlf88WWtoZWV2755PWVknjJlER4dpgzgOiLNu6kF3x+XWTisC6sd8HLNz3nXnle/7+g4+uev8nprdiPP561+HjQ+fH2Hj5ZcxAZUxNkJlGhaZZ21FZVZPnPUr8NROSynM9Tww94j+u9prfgCgUNUXRJcPo+z2Fo24bJptoGXp4mJiP7DOzcrMbLRP51rQZhjSpAGNQibSHLN2qsj5iNB4AA01as+C3avOIs2+vPFxhCaJ04A6xKdA9GniLFTnU1QHaIKQJjo4eHOoN6EJCUndi/qYgkeWY5HGkNCUERqqTRqjiQeaJe47UBukIVaBNtdIbBaQ2IA2eUwbmhqiDdJkbQWvUJuFmUizpTD9CqUpiT6F2lwdd2vb0cnMLZEGtRkN2hiKNPIpCsUyRrODOsVpTgjaxB4HmmKRpotTk/QWmUduDaROUW2ABiLMnApmTiHN89oYik4JnVKwThGaSqcKyE15zM4q4hRos+s8VOr4WUYTNx9iTGkOGRs1UposcOpG8upWrk1HOimUPnXqtDfLDa0T5kY91kXJnWI0/TA3aXLu1AYhxaJTrOCCU2EkN+fE3GC/eYqTsVX+mJtCSgNOQYp5bjDFojZKk4GaNKDNSE1tSIqRpjyBdgppdgHNbtQGUhxGtPEStKFORUbyTqE2tXe3CCkuIZ0SaMCposumFhaojYl9Nxq+/XiKHXmKYzZWedyB5XcNGk46NYPRhM/H5YfalPJOLWKd4ikmNOtZp04Fi9qkcm3UatCG0fgInRqE+0ZKdnG8qA2l0XBKg8bGKz/j/pBSnuIGmhu+b5oxxUDTdOQpphg6xXMjbECaYurUaA1t0pg2PMUsN2TfkE4RbWLF7dcegTRCbv4gKcZOJQsNT+lIv0I7hQ2HFGPDu2pDcmP/AhrxTvGG*4.2pxRwp1bimToppLiY7mLUJkkjN+jUxS4NT+lIF5wi2+8qaThPcTanqdNouC7RRqpQUKcOku1XSTtFG+7rSxoOKeadCm9PpLuYONUo7JuLs5OxU5n+vOFNjGYUa/jREKrNZU1t2C7uu1N9d6rvTv1v75Rbr7pTLr3oTnUqL/SeO9WpbHToNXeq08VIKhH/U/Iu/6kd9D9Vj/8pCDH/T9Xguun+n3rI/lORBQVzuv2nnmr+pza9+E6ZlT1GGOFOQcX3S2VnIDjx+NmE4FRWEh62/6pJcmbuqYk9y6KDSBE2Nn7/wj4uPbT0odEleqzIdxOocOv4NyNWSm66Z9ORoKfPtLVVrkdfcKesyiwJjIQAwdzWuQ3zI5uf2OjS+YVMfzKDyHxLJo3MADJynP1kpGR+piOTyRQKxRk68fmhqd3vlJuPum2/pAdGnu9t9/ydqrun1TMwgJOhKhrRAv9wNf2HQ518DIx7CEYikZaqXGHnQJT3DgUu02zLFlsZe/sPNtunPgKsa4cAAAAASUVORK5CYII=);
}

.battle-room .anim-ctx .user-anim .state-box {
  position: absolute;
  height: 24 * 4.2px;
  width: 100%;
}

.battle-room .anim-ctx .user-anim .state-box .state-box-inner {
  width: 100%;
  height: 100%;
}

.battle-room .anim-ctx .user-anim .state-box .state-box-inner .state-img {
  width: 90%;
  height: 10 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.battle-room .anim-ctx .user-anim .state-box .state-box-inner .loading-anim {
  position: relative;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  -webkit-animation: loadingBkgKf 2.7s linear 0s 1;
  animation: loadingBkgKf 2.7s linear 0s 1;
}

@-webkit-keyframes loadingBkgKf {
  0% {
    background-size: 100% 100%;
  }

  100% {
    background-size: 100% 100%;
  }
}

@keyframes loadingBkgKf {
  0% {
    background-size: 100% 100%;
  }

  100% {
    background-size: 100% 100%;
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-bk1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingBk1Kf 0.9s linear 0s infinite;
  animation: loadingBk1Kf 0.9s linear 0s infinite;
}

@-webkit-keyframes loadingBk1Kf {
  0% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
  }

  25% {
    opacity: 1;
    -webkit-transform: rotateZ(-120deg);
    transform: rotateZ(-120deg);
  }

  100% {
    opacity: 1;
    -webkit-transform: rotateZ(-120deg);
    transform: rotateZ(-120deg);
  }
}

@keyframes loadingBk1Kf {
  0% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
  }

  25% {
    opacity: 1;
    -webkit-transform: rotateZ(-120deg);
    transform: rotateZ(-120deg);
  }

  100% {
    opacity: 1;
    -webkit-transform: rotateZ(-120deg);
    transform: rotateZ(-120deg);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-bk2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingBk2Kf 0.9s linear 0s infinite;
  animation: loadingBk2Kf 0.9s linear 0s infinite;
}

@-webkit-keyframes loadingBk2Kf {
  0% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
  }

  25% {
    opacity: 1;
    -webkit-transform: rotateZ(120deg);
    transform: rotateZ(120deg);
  }

  100% {
    opacity: 1;
    -webkit-transform: rotateZ(120deg);
    transform: rotateZ(120deg);
  }
}

@keyframes loadingBk2Kf {
  0% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
  }

  25% {
    opacity: 1;
    -webkit-transform: rotateZ(120deg);
    transform: rotateZ(120deg);
  }

  100% {
    opacity: 1;
    -webkit-transform: rotateZ(120deg);
    transform: rotateZ(120deg);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-anim-kf
  0% {
  opacity: 0.1;
  -webkit-transform: scaleX(0.1);
  -ms-transform: scaleX(0.1);
  transform: scaleX(0.1);
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-anim-kf
  20% {
  opacity: 1;
  -webkit-transform: scaleX(1);
  -ms-transform: scaleX(1);
  transform: scaleX(1);
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-anim-kf
  80% {
  opacity: 1;
  -webkit-transform: scaleX(1);
  -ms-transform: scaleX(1);
  transform: scaleX(1);
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-anim-kf
  100% {
  opacity: 0.1;
  -webkit-transform: scaleX(0.1);
  -ms-transform: scaleX(0.1);
  transform: scaleX(0.1);
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-anim-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingImgKf1 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0s
    infinite;
  animation: loadingImgKf1 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0s infinite;
}

@-webkit-keyframes loadingImgKf1 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

@keyframes loadingImgKf1 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-img1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingImgKf1 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0s 1;
  animation: loadingImgKf1 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0s 1;
}

@keyframes loadingImgKf1 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-img2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingImgKf2 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0.9s 1;
  animation: loadingImgKf2 0.9s cubic-bezier(1, 0.39, 1, 0.82) 0.9s 1;
}

@-webkit-keyframes loadingImgKf2 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

@keyframes loadingImgKf2 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .loading-img3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 27.2 * 4.2px;
  height: 21.33 * 4.2px;
  opacity: 0;
  -webkit-animation: loadingImgKf3 0.9s cubic-bezier(1, 0.39, 1, 0.82) 1.8s 1;
  animation: loadingImgKf3 0.9s cubic-bezier(1, 0.39, 1, 0.82) 1.8s 1;
}

@-webkit-keyframes loadingImgKf3 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

@keyframes loadingImgKf3 {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }

  20% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: scaleX(0.1);
    transform: scaleX(0.1);
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .state-loading {
  margin: 5.33 * 4.2px 0 0 8.27 * 4.2px;
  opacity: 1;
  -webkit-animation: loadingKf 2.7s linear 0s 1;
  animation: loadingKf 2.7s linear 0s 1;
}

@-webkit-keyframes loadingKf {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes loadingKf {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.battle-room
  .anim-ctx
  .user-anim
  .state-box
  .state-box-inner
  .loading-anim
  .state10-loading {
  margin: 5.33 * 4.2px 0 0 8.27 * 4.2px;
  opacity: 1;
}

.battle-room .anim-ctx .user-anim .state-box .ready-wait {
  width: 8 * 4.2px;
  height: 8 * 4.2px;
}

.battle-room .anim-ctx .user-anim .state-box .state-loading1.vux-spinner {
  stroke: #5873dd !important;
  fill: #5873dd !important;
  vertical-align: middle;
  display: inline-block;
}

.battle-room .anim-ctx .user-anim .state-box .img-win {
  width: 48 * 4.2px;
  height: 54.894px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 {
  width: 29.87 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .user-info {
  width: 31.87 * 4.2px;
  height: 30.13 * 4.2px;
  margin: 0 0 0 -1.13 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .avatar-box
  .avatar-inner {
  position: relative;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .user-info .nick-name {
  margin-top: 0.4 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .user-info .nick-name .nick {
  font-size: 3.33 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .user-info .win-price {
  position: relative;
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-top {
  position: absolute;
  width: 100%;
  font-size: 3.33 * 4.2px;
  margin-top: 1.07 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-top
  .top-m-anim {
  display: inline-block;
  margin-top: 4rpx;
  -webkit-animation: userMKfLeft 0.5s ease-in 1;
  animation: userMKfLeft 0.5s ease-in 1;
}

@keyframes userMKfLeft {
  0% {
    margin-top: 30px;
    opacity: 0.3;
  }

  100% {
    margin-top: 0;
    opacity: 1;
  }
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-btm {
  position: absolute;
  width: 100%;
  font-size: 2.67 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-btm
  .btm-m-aim {
  display: inline-block;
  margin-top: 8 * 4.2px;
  -webkit-animation: userMKfRight 0.5s ease-in 1;
  animation: userMKfRight 0.5s ease-in 1;
}

@keyframes userMKfRight {
  0% {
    margin-top: 60px;
    opacity: 0.5;
  }

  100% {
    margin-top: 60px;
    opacity: 1;
  }
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-btm
  .btm-m-aim
  .orig-money {
  opacity: 0.7;
  margin-left: 0.67 * 4.2px;
}

.battle-room
  .anim-ctx
  .user-anim.user-anim-3
  .user-info
  .win-price
  .user-m-btm
  .btm-m-aim
  .orig-money-d {
  text-decoration: line-through;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .user-info .win-price .coin {
  width: 5.07 * 4.2px;
  height: 5.07 * 4.2px;
  margin-right: 0.53 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-3 .item-outer .index-tag {
  right: -4.4 * 4.2px;
  top: 12 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-2 {
  width: 42.13 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-2 .user-info {
  width: 44.67 * 4.2px;
  height: 30.13 * 4.2px;
  margin: 0 0 0 -1.4 * 4.2px;
}

.battle-room .anim-ctx .user-anim.user-anim-2 .item-outer .index-tag {
  right: -6.27 * 4.2px;
  top: 12 * 4.2px;
}

.battle-room .anim-ctx .user-anim-ready.user-anim-3 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 12.8 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-ready.user-anim-3 .user-info {
  background-image: url("../../assets/images/room_ready3.png");
}

.battle-room .anim-ctx .user-anim-ready.user-anim-2 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 18.13 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-ready.user-anim-2 .user-info {
  background-image: url("../../assets/images/user_ready_top2.png");
}

.battle-room .anim-ctx .user-anim-wait.user-anim-3 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURSha//xycNEAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 12.8 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-wait.user-anim-3 .user-info {
  background-image: url("../../assets/images/room_wait3.png");
}

.battle-room .anim-ctx .user-anim-wait.user-anim-2 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURSha//xycNEAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 18.13 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-wait.user-anim-2 .user-info {
  background-image: url("../../assets/images/user_wait_top2.png");
}

.battle-room .anim-ctx .user-anim-loss.user-anim-3 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURX19pcd+lgUAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 12.8 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-loss.user-anim-3 .user-info {
  background-image: url("../../assets/images/user_lose_top3.png");
}

.battle-room .anim-ctx .user-anim-loss.user-anim-2 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURX19pcd+lgUAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 18.13 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-loss.user-anim-2 .user-info {
  background-image: url("../../assets/images/user_lose_top2.png");
}

.battle-room .anim-ctx .user-anim-anim.user-anim-3 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 12.8 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-anim.user-anim-3 .user-info {
  background-image: url("../../assets/images/room_ready3.png");
}

.battle-room .anim-ctx .user-anim-anim.user-anim-2 {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
    no-repeat top 18.13 * 4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-anim.user-anim-2 .user-info {
  background-image: url("../../assets/images/user_ready_top2.png");
}

.battle-room .anim-ctx .user-anim-win.user-anim-3 {
  background: url("../../assets/images/win2_box_bg2.png") no-repeat top 12.8 *
    4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-win.user-anim-3 .user-info {
  color: #fff;
  background-image: url("../../assets/images/user_win_top3.png");
}

.battle-room .anim-ctx .user-anim-win.user-anim-3 .prod-item {
  background-image: url("../../assets/images/item_bkg2.png");
}

.battle-room .anim-ctx .user-anim-win.user-anim-2 {
  background: url("../../assets/images/win2_box_bg2.png") no-repeat top 18.13 *
    4.2px center / 100% 100%;
}

.battle-room .anim-ctx .user-anim-win.user-anim-2 .user-info {
  color: #fff;
  background-image: url("../../assets/images/user_win_top2.png");
}

.battle-room .anim-ctx .user-anim-win.user-anim-2 .prod-item {
  background-image: url("../../assets/images/item_bkg2.png");
}

.battle-room .anim-ctx .user-anim-win .user-info .type-box .tag {
  background: rgba(160, 127, 34, 0.7);
}

.battle-room .battle-room-div {
  position: relative;
  bottom: 26.67 * 4.2px;
  width: 100%;
  height: 11.33 * 4.2px;
  font-size: 3.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/battle_room_view.png");
  -webkit-animation: alphaInKf01 1s linear 1;
  animation: alphaInKf01 1s linear 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes alphaInKf01 {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes alphaInKf01 {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.tag-slide-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.tag-slide-item .item-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
}

.tag-slide-item .title {
  width: 21.33 * 4.2px;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  text-align: center;
  font-size: 2.4 * 4.2px;
  color: white;
  padding: 0 1.33 * 4.2px;
  margin: -0.67 * 4.2px 1.73 * 4.2px 0;
}

.tag-slide-item .run-active {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 13.33 * 4.2px;
  height: 13.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/run-active.png");
}

.tag-slide-item .price {
  z-index: 5;
  position: absolute;
  left: 0;
  bottom: 0.8 * 4.2px;
  width: 100%;
  height: 3.47 * 4.2px;
  line-height: 3.47 * 4.2px;
  text-align: center;
  font-size: 2.67 * 4.2px;
  color: #fff;
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAaCAMAAACUyBKuAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAADtUExURScpYzwzX/+qOf+aPP+cPCgpY21OVicpYgAAACgqY/+aPFhDWycpYycnZP//AFVVVf+qVf+SSf+fQCsrYi8uYikqYy4tYisrYzQxYf+AAC0sYjEuYTYwYDozYP+ZMzcxYDszYP+2SUU5XkQ5Xv+cPf+UQ/+dO1RBW2tNVzo0YE09XFZCW/+cPf+cPWNJWFdCW/+bQ/+gOv+ZZv+aPf+hO/+dO04+XP+YPv+ePP+kN/+bPv+fPiwsYScqZCcqYjMzZiYzZicpYwAAgCcpYisrYycpYycpZCgqYiYqZCcpYgAAVSYpYyoqZf/fgfragD4byX4AAABNdFJOU+bpCURN5u7fAOYm68lUAQMDBwjm5+bn5ucC5+fo6AXo6Afp6TsTGuvu6OrrNkPt6xcjBT8eDeolTA4pJR3KWwUUgwLaJN/kmZLkA6ArOLLvMQAAALpJREFUSMft1sURAlEURNFGBj42uLu7u7sz5B8OgxYJ9IIqbgJn9QRCzUhpOpuLxXK9NUIIWZYkCYSsNvtqs98BsiPm9IX8XhIiJocjgsluNhEJu0FDznAMc/1SOuqRaMgFrcYocy2nAhzjgcDZqQyUWi9uAgs5wdVs65VCvsgyVASuc*4.2pxvGOoamgErtGadaliIBv7G3/hZgz+D4O8SNfZOvEfe7Y+4N+oZ9da+Yv4M74i/z5fB+uE+3QDqTB+vDEhyzQAAAABJRU5ErkJggg==);
  margin-top: -4 * 4.2px;
}

.tag-slide-item .price .coin {
  width: 2 * 4.2px;
  height: 2 * 4.2px;
  margin-right: 0.27 * 4.2px;
}

.tag-slide-item .price .price-data {
  font-family: "Alimama ShuHeiTi", serif;
}

.bt-open-anim {
  position: relative;
}

.bt-open-anim .open-round {
  left: 40 * 4.2px;
  width: 20 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #34f3ff;
  text-align: center;
  z-index: 20;
}

.open-anim-3 {
  position: relative;
  width: 100%;
  height: 29.47 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/anim_bg0.png");
}

.open-anim-3:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-size: 100% 100%;
  background-image: url("../../assets/images/anim_bg0.gif");
}

.open-anim-3 img {
  border: none;
  outline: none;
}

.open-anim-3 .top-line {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100 * 4.2px 29.47 * 4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/anim_bg1.png");
}

.open-anim-3 .top-line .inner-gif {
  height: 100%;
  opacity: 0.5;
  margin-top: 0px;
  background-size: 100 * 4.2px 29.33 * 4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/anim_bg1.gif");
}

.open-anim-3 .list-box {
  height: 26 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 2 * 4.2px 1.33 * 4.2px 0;
}

.open-anim-3 .list-box .item-box {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 99.666px;
  height: 66.52px;

  background-size: 100% 100%;
}

.open-anim-3 .list-box .item-box.blue {
  background-image: url("../../assets/images/bk_blue.png");
}

.open-anim-3 .list-box .item-box.golden {
  background-image: url("../../assets/images/bk_golden.png");
}

.open-anim-3 .list-box .item-box.red {
  background-image: url("../../assets/images/bk_red.png");
}

.open-anim-3 .list-box .item-box.purple {
  background-image: url("../../assets/images/bk_purple.png");
}

.open-anim-3 .list-box .item-color {
  height: 54.894px;
  width: 19.73 * 4.2px;
  margin-left: 2 * 4.2px;
}

.open-anim-3 .list-box .item-prize {
  position: absolute;
  height: 54.894px;
  width: 99.666px;
}

.open-anim-3 .list-box .item-light {
  position: absolute;
  height: 54.894px;
  width: 54.894px;
  margin-left: 0.93 * 4.2px;
  -webkit-animation: frameLight-data-v-69c9e31b 1s steps(25) infinite;
  animation: frameLight-data-v-69c9e31b 1s steps(25) infinite;
  background-size: cover;
}

@-webkit-keyframes frameLight-data-v-69c9e31b {
  0% {
    background-position-y: 0px;
  }

  100% {
    background-position-y: -2450px;
  }
}

@keyframes frameLight-data-v-69c9e31b {
  0% {
    background-position-y: 0px;
  }

  100% {
    background-position-y: -2450px;
  }
}

.open-anim-3 .list-box .item-prod {
  // position: absolute;
  height: 55px;
  width: 19.73 * 4.2px;
  padding: -2.8 * 4.2px -2.55 * 4.2px;
  // -o-object-fit: scale-down;
  object-fit: scale-down;
}

.open-anim-3 .list-box .outer-box {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 26.13 * 4.2px;
}

.open-anim-3 .list-box .outer-box .box-alpha {
  position: absolute;
  width: 100%;
  height: 100%;
}

.open-anim-3 .list-box .inner-box {
  display: inline-block;
  width: 99.666px;
  height: 26.13 * 4.2px;
  overflow: hidden;
}

.open-anim-2 {
  position: relative;
  width: 100%;
  height: 29.47 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/anim_bg0.png");
}

.open-anim-2:before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-size: 100% 100%;
  background-image: url("../../assets/images/anim_bg0.gif");
}

.open-anim-2 img {
  border: none;
  outline: none;
}

.open-anim-2 .top-line {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100 * 4.2px 29.47 * 4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/anim_bg1.png");
}

.open-anim-2 .top-line .inner-gif {
  height: 100%;
  opacity: 0.5;
  margin-top: 0px;
  background-size: 100 * 4.2px 29.33 * 4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/anim_bg1.gif");
}

.open-anim-2 .list-box {
  height: 26 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 2 * 4.2px 1.33 * 4.2px 0;
}

.open-anim-2 .list-box .item-box {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 99.666px;
  height: 66.52px;

  background-size: 100% 100%;
}

.open-anim-2 .list-box .item-color {
  height: 54.894px;
  width: 19.73 * 4.2px;
  margin-left: 2 * 4.2px;
}

.open-anim-2 .list-box .item-prize {
  position: absolute;
  top: 0;
  left: 0;
  height: 54.894px;
  width: 99.666px;
  background: #9f7f2f;
}

.open-anim-2 .list-box .item-light {
  position: absolute;
  height: 54.894px;
  width: 54.894px;
  margin-left: 0.93 * 4.2px;
  -webkit-animation: frameLight-data-v-69c9e31b 1s steps(25) infinite;
  animation: frameLight-data-v-69c9e31b 1s steps(25) infinite;
  background-size: cover;
}

@keyframes frameLight-data-v-69c9e31b {
  0% {
    background-position-y: 0px;
  }

  100% {
    background-position-y: -2450px;
  }
}

.open-anim-2 .list-box .item-prod {
  // position: absolute;
  height: 55px;
  width: 19.73 * 4.2px;
  // padding: -2.8 * 4.2px -2.55 * 4.2px;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.open-anim-2 .list-box .outer-box {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 26.13 * 4.2px;
}

.open-anim-2 .list-box .outer-box .box-alpha {
  position: absolute;
  width: 100%;
  height: 100%;
}

.open-anim-2 .list-box .inner-box {
  display: inline-block;
  width: 99.666px;
  height: 26.13 * 4.2px;
  overflow: hidden;
}
@media only screen and (max-width: 430px) {
  .battle-detail {
    --head-height: 14vw;
  }

  .battle-room .detail-content .filter-flex .info-box {
    height: 28vw;
  }

  .battle-room .detail-content .filter-flex .info-box .info-inner {
    width: 96.8vw;
    height: 26.8vw;
    margin:   0 1.6vw;
    padding: 8vw 0 0 0;
  }

  .battle-room .detail-content .filter-flex .info-box .info-bg1 {
    top: 3.33vw;
    left: 20.8vw;
    width: 54.93vw;
    height: 1.73vw;

    background-position: left -0.67vw center;
    background-size: 108vw 100%;
  }

  .battle-room .detail-content .filter-flex .info-box .info-id {
    top: 2.53vw;
    right: 11.33vw;
    width: 24vw;
    height: 2.4vw;
    line-height: 2.4vw;

    font-size: 2.27vw;
  }

  .battle-room .detail-content .filter-flex .info-box .round-info {
    top: 3.33vw;
    left: 8.67vw;
    width: 16vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 3.33vw;
  }

  .battle-room .detail-content .filter-flex .info-box .round-info .round-ic {
    width: 2.93vw;
    height: 2.4vw;
    margin: 1.07vw 0 0 0.27vw;
  }

  .battle-room .detail-content .filter-flex .info-box .amount-info {
    top: 3.33vw;
    left: 31.73vw;
    width: 16.53vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 3.33vw;
  }

  .battle-room .detail-content .filter-flex .info-box .amount-info .coin {
    width: 4.27vw;
    height: 4.27vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list {
    height: 17.33vw;
    padding: 0 8vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list .swiper-box {
    height: 100%;
    padding-top: 2vw;
    padding-left: 0.67vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list .banner-action {
    font-size: 6.67vw;

    top: 14.67vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-action
    .svg-icon {
    padding: 0.67vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-action
    .svg-icon:hover {
    -webkit-border-radius: 3.33vw;
    border-radius: 3.33vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list .banner-last {
    font-size: 6.67vw;

    top: 14.67vw;
    z-index: 100;
    left: 4.67vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-last
    .svg-icon {
    padding: 0.67vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-last
    .svg-icon:hover {
    -webkit-border-radius: 3.33vw;
    border-radius: 3.33vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list .banner-next {
    font-size: 6.67vw;

    top: 14.67vw;
    z-index: 100;
    right: 5.33vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-next
    .svg-icon {
    padding: 0.67vw;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .banner-next
    .svg-icon:hover {
    -webkit-border-radius: 3.33vw;
    border-radius: 3.33vw;
  }

  .battle-room .detail-content .filter-flex .info-box .box-list .sel-item {
    width: 13.33vw;
    height: 13.33vw;
    margin: 0.4vw 1.33vw 0 0;
  }

  .battle-room
    .detail-content
    .filter-flex
    .info-box
    .box-list
    .sel-item.sel-item1 {
    margin: 0.4vw 1.33vw 0 1.33vw;
  }

  .battle-room .detail-content .filter-flex .anim-box::-webkit-scrollbar {
    width: 0.27vw;
    height: 0.27vw;
  }

  .battle-room .detail-content .filter-flex .btm-cover {
    height: 14.53vw;
    position: fixed;
    bottom: 0;
  }

  .battle-room .room-title {
    top: -4vw;

    margin-bottom: 2.67vw;

    font-size: 2.4vw;
  }

  .battle-room .pk-anim-box {
    height: 26.67vw;
    margin: 31.33vw 0 0 0;
  }

  .battle-room .pk-anim-box.pk-anim-box-d {
    margin: 31.47vw 0 0 0;
  }

  .battle-room .pk-anim-box .wait-box {
    width: 100%;
    height: 20vw;
    margin-top: 1.33vw;
  }

  .battle-room .pk-anim-box .wait-box .wait-anim {
    width: 65.07vw;
    height: 26vw;
    margin: 0 0 0 17.47vw;
  }

  .battle-room .anim-ctx {
    margin-top: 0.67vw;
    padding: 0 1.33vw 13.33vw;
  }

  .battle-room .anim-ctx .user-anim {
    min-height: 150.67vw;
  }

  .battle-room .anim-ctx .user-anim .user-content .join-btn {
    margin-top: 4.67vw;
  }

  .battle-room .anim-ctx .user-anim .user-content .join-btn .user-join-btn {
    width: 33.33vw;
    height: 8.13vw;
    line-height: 8.13vw;
    font-size: 3.73vw;
  }

  .battle-room .anim-ctx .user-anim .failed-join {
    height: 8vw;
    margin-top: 2vw;
  }

  .battle-room .anim-ctx .user-anim .failed-join .again-btn {
    width: 29.33vw;
    height: 7.07vw;
    line-height: 7.07vw;

    font-size: 2.13vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list {
    margin: 0.67vw 0.53vw 6.67vw;
    padding-bottom: 20vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .item-outer {
    margin: 0 0 1.6vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .item-outer .index-tag {
    width: 5.07vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 2.67vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item-empty {
    height: 20.53vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item {
    width: 28.67vw;
    height: 28.67vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .color-bg {
    top: 2.8vw;
    left: 2vw;
    width: 24.53vw;
    height: 16.8vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .prod-tag {
    top: 0.67vw;
    right: 0.67vw;
    width: 11.6vw;
    height: 6.27vw;
    line-height: 6.27vw;
    font-size: 3.33vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-img {
    height: 19.47vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-img .prod {
    margin-top: 2.67vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .level {
    height: 4vw;
    line-height: 4vw;
    font-size: 2.67vw;

    padding: 0 2.67vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .title {
    width: 100%;
    height: 4vw;
    line-height: 4vw;
    font-size: 2.67vw;

    padding: 0 2.67vw;
  }

  .battle-room .anim-ctx .user-anim .prod-list .prod-item .inner-info .money {
    height: 9.07vw;
    line-height: 9.07vw;

    font-size: 3.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .prod-list
    .prod-item
    .inner-info
    .money
    .coin {
    width: 3.87vw;
    height: 3.6vw;
    margin-right: 0.67vw;
  }

  .battle-room .anim-ctx .user-anim .user-info {
    height: 30.13vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .is-me {
    top: 0.4vw;
    right: 1.2vw;
    width: 6.67vw;
    height: 6.67vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .avatar-box .avatar-inner {
    width: 13.33vw;
    height: 13.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .user-info
    .avatar-box
    .avatar-inner
    .a-img {
    padding: 0.27vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .avatar-box .action-img {
    top: 2.67vw;
    right: 2.67vw;
    width: 8.8vw;
    height: 10.27vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .avatar-box .action-img .img {
    width: 6.13vw;
    height: 4.27vw;
    margin: 2.13vw 0 0 1.47vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .nick-name {
    margin-top: 0.93vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .nick-name .nick {
    width: 24.8vw;
    height: 4.27vw;
    line-height: 4.27vw;
    font-size: 3.33vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .win-price .user-m-top {
    font-size: 3vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .win-price .user-m-btm {
    font-size: 2.93vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .user-info
    .win-price
    .user-m-btm
    .btm-m-aim {
    margin-top: 7.97vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .user-info
    .win-price
    .user-m-btm
    .btm-m-aim
    .orig-money {
    opacity: 0.7;
    margin-left: 0.67vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .win-price .coin {
    width: 5.07vw;
    height: 5.07vw;
    margin-right: 0.53vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .action-box .user-actions {
    height: 6.13vw;
  }

  .battle-room .anim-ctx .user-anim .user-info .action-box .user-actions image {
    width: 4vw;
    height: 4vw;

    margin: 0.67vw auto;
  }

  .battle-room .anim-ctx .user-anim .top-box {
    height: 24vw;

    margin: 4.67vw 0 2.67vw;
  }

  .battle-room .anim-ctx .user-anim .top-box .result-box .win-result {
    width: 35.07vw;
    height: 15.87vw;
  }

  .battle-room .anim-ctx .user-anim .top-box .result-box .win-result1 {
    position: relative;
    width: 23.73vw;
    height: 16.67vw;
    background-size: 23.73vw 13.07vw;
    background: url("../../assets/images/win_bg3.png") no-repeat top center /
        23.73vw 13.07vw,
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAXCAMAAADOf8o0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAP/Fpf/IXf/GVf/8+f/bmv/BT//15P/9+f/ksP+1nv/flP/CUP/Vgf/////fpP/////jnv/Pbf/KYf/35//GV//EUv/DUf/NbP/EU//Ma//EUv/EUv/KYf/nuf/z2v/Yjf/Maf/x0f/ovf/GV//FVP/z3f/z3//IWP/EV//GVv/GWP/ZkP/ls//Pdf/FUv/IWv/KZf/Whf/LZP/78//doP/Se//KY//57P/lsf/EVv/iqf/w0//Wif/FU//fpP/DWP/GVP/fof/GVP/89f/14f/FUv/8+f/MZv/GVf/EUf/67//EVP/9+f/Te//Tev/IXv/Whf/Tev/Naf/pvP/ai//KYf/ZmP/lsf/ty//ipv/GVP/w0P/rxv/03v/pvP/24//cmf/alv/tyv/sxv/Xkf/Whv/v0f/w0P/uzf/syP/Rd//iq//Pcv/y2P/ntv/IWv/ntv/z3v/iq//dm//blv/Zkf/25v/syv/lsf/Xiv/pu//14//IXf/89f/v0f/sxv/dnP/hpv/foP/Pcv/JYP/jqv/55f/IXv/jq//FVf/t3P/GV//Vgf/ReP/LZf/UgP/25P/Qcf/FUv/47v/////blf/89v/57f/Vhv/ETv/EUv/Se//Re//Pcv/Pc//JYf/JYv/Qcv/Vhf/Ujf/Pcv/Yj//Pc//dm//hsP/HWf/FUv/JY//Sev/IYP/ou//GWv/GWv/blP/Naf/pu//46//25P/15f/Whv/qxP/35P/Whf/jsP/em//lsP/cmv/w0f/8+v/ou//tx//fpP/v0f/z2v/sx//akP/ipv/Maf/y2v/36//UhP/04v/Rdf/dnP/pu//YkP/78//++v/36//68//FVf/////////9+f/14v/24//47P/47P//+v/9+v/////78//47P/14//JYf/HWf/DUv/EUf/qwf/Yi//89//EUv/dm//78//57P/Whf/ZkP/hpv/FVf/SfP/z2v/Pcv/Maf/HWv/24//JYf/sxv/w0P/lsP/pu//++qp4sbEAAADsdFJOUwACBedRKx3EguABBS0YEBTOCRQEQTr6W0q3ONDnLXOTG9TUHcfzJBMYJFKH6kpa2/kQ4uxzT4Tn+PROkZ+J1qYqcIWkuVCfpIePtB5Br/kur+Xk+i0i+i+oqfdd8Llz8pBXwnPxRqjh7ZFC68uvh6zogqlz+3urhITsdLl5Skrj+m/f6ZuCMTqV1NAdwcrRe4blhntbjNDTadAN3fJu/VCl0/7dL+aPpNsqmoBV28ST4WMrGfG32dT+Snv0uav9kvddhJqYy+OeuHu/8Mu/R16Y2Ph966mp7jyVqbnY6bAw8g/r0/zQ0KuB8ef+R91QPwAABGpJREFUSMellHdUFFcUxi9DXIKL7MIWUIpIbwHBoCggTSGARmNNRI0aY4xRExO7Jhp7RY2JJqb3XjW999577+WP3Znd2TqzLfe9KbsDe07+yHfOvHvf9713f3uYXQAArjMavwWQmsnwP5WWSjUY4NfUVDAajd8oyXeRyATaTI5EjkNJZ2en5BefNlA9NHn19Hii0ZkRqi9+hl8iEcDuKgXzFcvKGJY9Dj0sy0r+9exAXUuTCWw8SRh58zmw7G/4sCrmS477wGzeDfATx/0OPRzHyRhuoCTMk1w8SRiOq6+v57h1CRz3oxndzWazuYQklwtER0r2fy8IP+zfjb2EmZgk6Ygg/CG3SR/RZIG8exrPPqVESTSaLwgL4DlBWFcsRDWRYjxEbzV6VGnf6nCP5/347xsTT7HWmu/xDIfNHs/KldFxHoo5Lxh8ZcuWNxuDipZqb14cDM6Nj5mLh9O01gXBYGMx3li/NBi8KD9Ilvz8ZRQTCMzD8nZA1tbX+2ECgcVxKcvw8LwZg7UYecj6xYGtBYDNs0pyaTi8CYuhYFM4/GlBQUn/aY+Gw6fiURJOhYlm5ObmGlQzNyzptfPDqwCwOUNJzg2FXpB4odBe2JWcvJzuDMmyxoZCLyl9cgwG7xHdj486C64IhcZuwBurNjTgTo3ampu38fz25jd2ATTw/Dao4/m9EoaPozlRykLZ0s/h+eVRDM83wLs835aXgMK4DgvAMbus1QBX2+3b4RO7fZGEscfRanVenWLp78NlpmLjjJdhjd3e9mLMrdlwzKnIABfimveZ07mGXjANkjQb3Uq5H/SEMu4ecmVRJS56cq1S+cJtdDrfWbjW6Wxa64zqLrjB4TjY1LTE4XAYIA/XD/EZonnTM9F55vla7ds/B01HrZ4UPdTieqfM2eiQdHiJI6op0Od2HwYY5na70wEOuon6NBNND1Pzklhv9NnEmpYG07AwkEe2N92cQCO3pNE1Q1DYVGHRQ5/Xew1ivF4vYqq8RFWaz72Cel4N5hbi3KsHuBsrA3DrHcSYQqIdXu+Oj1fQoSh0M2kzwuc7CzE+nw8xJ7H4RsT+3k5i7puOy6hYDDmWSY6NwQYxkDkdmxwSvYcJHKJDpYMS5k9RJBhRFNOZnaOwiLP2qOPSp84izkOPiKIGI4q3ldJmDKYEA2W3i2KO7AyDQ6K4Uz4oXkmbv/z+CgCL3+/vuswv67FekjCPF44ku5HlcABXS0uLpbz1gQoSTc2ReeQKI/1xJxUScxwapbCHDkXhTsLsc7msRUVWl8t1AB9XYjtZ95FkqItqfApAu0vVUM33IxEdRn2N+PTiBQtx2xOJsPkaSyFk2WRld9ts1q4a01HssyiGur0m8hltqrSYbHSYWCPDZiufRM79Y4vRjSrG2tpd1FVGTlqyFIy1e5yJXmY6rNKpovEP/hfmbxPBZFu0mLIUqrITkKL8kE0ZHaS09pbGfK91uhSdrqb/P+nC6upqDab8KAMtHRUZJxhdjEr/BW4bfVPHMCDxAAAAAElFTkSuQmCC)
        no-repeat bottom center / 13.6vw 3.07vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .top-box
    .result-box
    .win-result1
    .goods-img {
    width: 14vw;
    height: 10.67vw;

    margin: 1.33vw 0 0 4.8vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .top-box
    .result-box
    .win-result1
    .win-price {
    bottom: 4vw;
    width: 18.8vw;
    height: 4.13vw;
    line-height: 4.13vw;
    font-size: 3.33vw;

    padding: 0 1.07vw 0 0;
  }

  .battle-room .anim-ctx .user-anim .top-box .result-box .loss-result {
    width: 23.73vw;
    height: 16.67vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .top-box
    .result-box
    .loss-result
    .goods-img {
    width: 16vw;
    height: 10.67vw;

    margin: 1.33vw 0 0 3.73vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .top-box
    .result-box
    .loss-result
    .loss-name {
    top: 0.27vw;
    width: 18.8vw;
    height: 3.73vw;
    line-height: 3.73vw;
    font-size: 2.67vw;
    padding: 0 0 0 1.07vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .top-box
    .result-box
    .loss-result
    .loss-price {
    bottom: 4vw;
    width: 18.8vw;
    height: 4.13vw;
    line-height: 4.13vw;
    font-size: 3.33vw;
    text-align: right;
    padding: 0 1.07vw 0 0;
  }

  .battle-room .anim-ctx .user-anim .state-box {
    height: 24vw;
  }

  .battle-room .anim-ctx .user-anim .state-box .state-box-inner .state-img {
    height: 10vw;
  }

  .battle-room .anim-ctx .user-anim .state-box .state-box-inner .loading-anim {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-bk1 {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-bk2 {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-anim-img {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-img1 {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-img2 {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .loading-img3 {
    width: 27.2vw;
    height: 21.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .state-loading {
    margin: 5.33vw 0 0 8.27vw;
  }

  .battle-room
    .anim-ctx
    .user-anim
    .state-box
    .state-box-inner
    .loading-anim
    .state10-loading {
    margin: 5.33vw 0 0 8.27vw;
  }

  .battle-room .anim-ctx .user-anim .state-box .ready-wait {
    width: 8vw;
    height: 8vw;
  }

  .battle-room .anim-ctx .user-anim .state-box .img-win {
    width: 48vw;
    height: 13.07vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 {
    width: 29.87vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 .user-info {
    width: 31.87vw;
    height: 30.13vw;
    margin: 0 0 0 -1.13vw;
  }

  .battle-room
    .anim-ctx
    .user-anim.user-anim-3
    .user-info
    .avatar-box
    .avatar-inner {
    position: relative;
    width: 13.33vw;
    height: 13.33vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 .user-info .nick-name {
    margin-top: 0.4vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 .user-info .nick-name .nick {
    font-size: 3.33vw;
  }

  .battle-room
    .anim-ctx
    .user-anim.user-anim-3
    .user-info
    .win-price
    .user-m-top {
    font-size: 3.33vw;
    margin-top: 1.07vw;
  }

  .battle-room
    .anim-ctx
    .user-anim.user-anim-3
    .user-info
    .win-price
    .user-m-btm {
    font-size: 2.67vw;
  }

  .battle-room
    .anim-ctx
    .user-anim.user-anim-3
    .user-info
    .win-price
    .user-m-btm
    .btm-m-aim {
    margin-top: 8vw;
  }

  .battle-room
    .anim-ctx
    .user-anim.user-anim-3
    .user-info
    .win-price
    .user-m-btm
    .btm-m-aim
    .orig-money {
    opacity: 0.7;
    margin-left: 0.67vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 .user-info .win-price .coin {
    width: 5.07vw;
    height: 5.07vw;
    margin-right: 0.53vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-3 .item-outer .index-tag {
    right: -4.4vw;
    top: 12vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-2 {
    width: 42.13vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-2 .user-info {
    width: 44.67vw;
    height: 30.13vw;
    margin: 0 0 0 -1.4vw;
  }

  .battle-room .anim-ctx .user-anim.user-anim-2 .item-outer .index-tag {
    right: -6.27vw;
    top: 12vw;
  }

  .battle-room .anim-ctx .user-anim-ready.user-anim-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 12.8vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-ready.user-anim-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 18.13vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-wait.user-anim-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURSha//xycNEAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 12.8vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-wait.user-anim-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURSha//xycNEAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 18.13vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-loss.user-anim-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURX19pcd+lgUAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 12.8vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-loss.user-anim-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURX19pcd+lgUAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 18.13vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-anim.user-anim-3 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 12.8vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-anim.user-anim-2 {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAANuAQMAAACxEieQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURfdBacr9/zcAAAABdFJOUzP/NrlwAAAAOklEQVR42u3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACADwOMngABHjcL8AAAAABJRU5ErkJggg==)
      no-repeat top 18.13vw center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-win.user-anim-3 {
    background: url("../../assets/images/win2_box_bg2.png") no-repeat top 12.8vw
      center / 100% 100%;
  }

  .battle-room .anim-ctx .user-anim-win.user-anim-2 {
    background: url("../../assets/images/win2_box_bg2.png") no-repeat top
      18.13vw center / 100% 100%;
  }

  .battle-room .battle-room-div {
    bottom: 26.67vw;

    height: 11.33vw;
    font-size: 3.33vw;
    position: fixed;
  }

  .tag-slide-item .item-img {
    width: 13.33vw;
    height: 13.33vw;
  }

  .tag-slide-item .title {
    width: 21.33vw;
    height: 4.27vw;
    line-height: 4.27vw;

    font-size: 2.4vw;

    padding: 0 1.33vw;
    margin: -0.67vw 1.73vw 0;
  }

  .tag-slide-item .run-active {
    width: 13.33vw;
    height: 13.33vw;
  }

  .tag-slide-item .price {
    bottom: 0.8vw;

    height: 3.47vw;
    line-height: 3.47vw;

    font-size: 2.67vw;
    margin-top: -4vw;
  }

  .tag-slide-item .price .coin {
    width: 2vw;
    height: 2vw;
    margin-right: 0.27vw;
  }

  .bt-open-anim .open-round {
    left: 40vw;
    width: 20vw;
    height: 5.33vw;
    line-height: 5.33vw;
    font-size: 3.33vw;
  }

  .open-anim-3 {
    height: 29.47vw;
  }

  .open-anim-3 .top-line {
    background-size: 100vw 29.47vw;
  }

  .open-anim-3 .top-line .inner-gif {
    background-size: 100vw 29.33vw;
  }

  .open-anim-3 .list-box {
    height: 26vw;

    padding: 4.4vw 1.33vw 0;
  }

  .open-anim-3 .list-box .item-box {
    width: 23.73vw;
    height: 66.52px;
  }

  .open-anim-3 .list-box .item-color {
    height: 13.07vw;
    width: 19.73vw;
    margin-left: 2vw;
  }

  .open-anim-3 .list-box .item-prize {
    height: 13.07vw;
    width: 23.73vw;
  }

  .open-anim-3 .list-box .item-light {
    height: 13.07vw;
    width: 13.07vw;
    margin-left: 0.93vw;
  }

  .open-anim-3 .list-box .item-prod {
    // height: 13.07vw;
    // width: 19.73vw;
    // padding: -2.8vw -2.55vw;
  }

  .open-anim-3 .list-box .outer-box {
    height: 26.13vw;
  }

  .open-anim-3 .list-box .inner-box {
    width: 23.73vw;
    height: 26.13vw;
  }

  .open-anim-2 {
    height: 29.47vw;
  }

  .open-anim-2 .top-line {
    background-size: 100vw 29.47vw;
  }

  .open-anim-2 .top-line .inner-gif {
    background-size: 100vw 29.33vw;
  }

  .open-anim-2 .list-box {
    height: 26vw;

    padding: 2vw 1.33vw 0;
  }

  .open-anim-2 .list-box .item-box {
    width: 23.73vw;
    height: 66.52px;
  }

  .open-anim-2 .list-box .item-color {
    height: 13.07vw;
    width: 19.73vw;
    margin-left: 2vw;
  }

  .open-anim-2 .list-box .item-prize {
    height: 13.07vw;
    width: 23.73vw;
  }

  .open-anim-2 .list-box .item-light {
    height: 13.07vw;
    width: 13.07vw;
    margin-left: 0.93vw;
  }

  .open-anim-2 .list-box .item-prod {
    // height: 13.07vw;
    // width: 19.73vw;
    // padding: -2.8vw -2.55vw;
  }

  .open-anim-2 .list-box .outer-box {
    height: 26.13vw;
  }

  .open-anim-2 .list-box .outer-box .box-alpha {
    width: 100%;
    height: 100%;
  }

  .open-anim-2 .list-box .inner-box {
    width: 23.73vw;
    height: 26.13vw;
  }
}
.swiper-container {
  overflow-x: scroll;
}
.swiper-container::-webkit-scrollbar {
  height: 2px;
}
.appview {
  height: calc(100vh - var(--head-height));
}
.battle-room {
  // padding-top: var(--head-height);
}
</style>
